import algoliasearch from 'algoliasearch';
import concat from 'lodash/concat';
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import hash from 'object-hash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import queryString, { stringify } from 'query-string';
import assign from 'lodash/assign';
import JWTDecode from 'jwt-decode';
import nookies, { parseCookies } from 'nookies';
import { DateTime } from 'luxon';
import Cookies from 'js-cookie';
import isEmpty from 'lodash/isEmpty';
import isbot from 'isbot';
import fetch$2 from 'cross-fetch';
import { parseDocument, Parser, DomUtils } from 'htmlparser2';
import render from 'dom-serializer';
import { Element, Text } from 'domhandler';
import { cloneDeep, compact as compact$1, flatten as flatten$1, camelCase } from 'lodash';
import fetchRetry from 'fetch-retry';
import { captureException, init as init$2 } from '@sentry/nextjs';
import { BrowserTracing } from '@sentry/tracing';
import FormData from 'form-data';
import flattenDeep from 'lodash/flattenDeep';
import flow from 'lodash/flow';

var StageOption = /* @__PURE__ */ ((StageOption2) => {
  StageOption2["DRAFT"] = "DRAFT";
  StageOption2["PUBLISHED"] = "PUBLISHED";
  return StageOption2;
})(StageOption || {});

var Product = /* @__PURE__ */ ((Product2) => {
  Product2["BCIQ"] = "BCIQ";
  Product2["BioCentury"] = "BioCentury";
  Product2["Infinity"] = "Identity";
  Product2["Conferences"] = "Conferences";
  Product2["Profiles"] = "Profiles";
  return Product2;
})(Product || {});
var GraphCMSModel = /* @__PURE__ */ ((GraphCMSModel2) => {
  GraphCMSModel2["Article"] = "Article";
  GraphCMSModel2["ArticlePackage"] = "ArticlePackage";
  GraphCMSModel2["Conference"] = "Conference";
  GraphCMSModel2["Page"] = "Page";
  return GraphCMSModel2;
})(GraphCMSModel || {});
var ContextType = /* @__PURE__ */ ((ContextType2) => {
  ContextType2["Nextjs"] = "Nextjs";
  ContextType2["Azure"] = "Azure";
  return ContextType2;
})(ContextType || {});
var FetchAPI = /* @__PURE__ */ ((FetchAPI2) => {
  FetchAPI2["DEFAULT"] = "default";
  FetchAPI2["IDENTITY"] = "identity";
  FetchAPI2["ARTICLE"] = "article";
  FetchAPI2["ALERT"] = "alert";
  return FetchAPI2;
})(FetchAPI || {});
var RestMethods = /* @__PURE__ */ ((RestMethods2) => {
  RestMethods2["GET"] = "GET";
  RestMethods2["POST"] = "POST";
  RestMethods2["PUT"] = "PUT";
  RestMethods2["DELETE"] = "DELETE";
  return RestMethods2;
})(RestMethods || {});
var ModelType = /* @__PURE__ */ ((ModelType2) => {
  ModelType2["Article"] = "Article";
  ModelType2["Company"] = "Company";
  ModelType2["Target"] = "Target";
  ModelType2["Product"] = "Product";
  ModelType2["Disease_Category"] = "Disease Category";
  ModelType2["Page"] = "Page";
  ModelType2["Search"] = "Search";
  ModelType2["Events"] = "Events";
  ModelType2["Whitepaper"] = "Whitepaper";
  return ModelType2;
})(ModelType || {});
var OrderOption = /* @__PURE__ */ ((OrderOption2) => {
  OrderOption2["ASC"] = "ASC";
  OrderOption2["DESC"] = "DESC";
  return OrderOption2;
})(OrderOption || {});
var QueryModel = /* @__PURE__ */ ((QueryModel2) => {
  QueryModel2["articlesConnection"] = "articlesConnection";
  QueryModel2["algolia"] = "algolia";
  return QueryModel2;
})(QueryModel || {});
var RoleType = /* @__PURE__ */ ((RoleType2) => {
  RoleType2["Admin"] = "Admin";
  return RoleType2;
})(RoleType || {});
var BlockTypeNamePlural = /* @__PURE__ */ ((BlockTypeNamePlural2) => {
  BlockTypeNamePlural2["buttonComponent"] = "buttonComponents";
  BlockTypeNamePlural2["carouselComponent"] = "carouselComponents";
  BlockTypeNamePlural2["checkoutButtonComponent"] = "checkoutButtonComponents";
  BlockTypeNamePlural2["collapsibleComponent"] = "collapsibleComponents";
  BlockTypeNamePlural2["companiesComponent"] = "companiesComponents";
  BlockTypeNamePlural2["conferenceSection"] = "ConferenceSections";
  BlockTypeNamePlural2["contentCardComponent"] = "contentCardComponents";
  BlockTypeNamePlural2["informativeCardComponent"] = "informativeCardComponents";
  BlockTypeNamePlural2["gridComponent"] = "gridComponents";
  BlockTypeNamePlural2["loginButtonComponent"] = "loginButtonComponents";
  BlockTypeNamePlural2["markdownComponent"] = "markdownComponents";
  BlockTypeNamePlural2["marketingCardComponent"] = "marketingCardComponents";
  BlockTypeNamePlural2["masoneryComponent"] = "masoneryComponents";
  BlockTypeNamePlural2["myFeedComponent"] = "myFeedComponents";
  BlockTypeNamePlural2["myFoldersComponent"] = "myFoldersComponents";
  BlockTypeNamePlural2["peopleComponent"] = "peopleComponents";
  BlockTypeNamePlural2["podcastButtonComponent"] = "podcastButtonComponents";
  BlockTypeNamePlural2["registerButtonComponent"] = "registerButtonComponents";
  BlockTypeNamePlural2["tabComponent"] = "tabComponents";
  BlockTypeNamePlural2["tabItemComponent"] = "tabItemComponents";
  BlockTypeNamePlural2["titleComponent"] = "titleComponents";
  return BlockTypeNamePlural2;
})(BlockTypeNamePlural || {});

var __async$s = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const client = algoliasearch(
  process.env.ALGOLIA_APP_ID || process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.ALGOLIA_API_KEY || process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
);
const INDICES = {
  [ModelType.Company]: process.env.ALGOLIA_BC_COMPANY_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_COMPANY_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_COMPANY_INDEX_NAME,
  [ModelType.Disease_Category]: process.env.ALGOLIA_BC_DISEASE_CATEGORY_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_DISEASE_CATEGORY_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_DISEASE_CATEGORY_INDEX_NAME,
  [ModelType.Product]: process.env.ALGOLIA_BC_PRODUCT_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_PRODUCT_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_PRODUCT_INDEX_NAME,
  [ModelType.Target]: process.env.ALGOLIA_BC_TARGET_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_TARGET_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_TARGET_INDEX_NAME,
  [ModelType.Page]: process.env.ALGOLIA_BC_COMMUNITY_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_COMMUNITY_INDEX,
  [ModelType.Search]: process.env.ALGOLIA_BC_SEARCH_INDEX || process.env.NEXT_PUBLIC_ALGOLIA_BC_SEARCH_INDEX
};
const initIndex = (modelType) => client.initIndex(INDICES[modelType]);
const saveObject = (_0) => __async$s(void 0, [_0], function* ({
  record,
  modelType
}) {
  return initIndex(modelType).saveObject(record);
});
const saveSynonym = (_0) => __async$s(void 0, [_0], function* ({
  record,
  modelType
}) {
  return initIndex(modelType).saveSynonym(record);
});
const saveSynonyms = (_0) => __async$s(void 0, [_0], function* ({
  records,
  modelType
}) {
  return initIndex(modelType).saveSynonyms(records);
});
const saveObjects = (_0) => __async$s(void 0, [_0], function* ({
  records,
  modelType
}) {
  return initIndex(modelType).saveObjects(records);
});
const deleteObject = (_0) => __async$s(void 0, [_0], function* ({
  id,
  modelType
}) {
  return initIndex(modelType).deleteObject(id);
});
const deleteObjects = (_0) => __async$s(void 0, [_0], function* ({
  ids,
  modelType
}) {
  return initIndex(modelType).deleteObjects(ids);
});
const clearObjects = (_0) => __async$s(void 0, [_0], function* ({
  modelType
}) {
  return initIndex(modelType).clearObjects();
});
const search = (queries) => __async$s(void 0, null, function* () {
  return client.search(queries);
});
const deleteBy = ({
  params,
  modelType
}) => initIndex(modelType).deleteBy(params);
const findObject = ({
  condition,
  params,
  modelType
}) => initIndex(modelType).findObject(condition, params);

var __defProp$e = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const contentTypeFacetKeys = /* @__PURE__ */ new Map([
  ["articles", ["type:Article"]],
  ["podcasts", ["type:Podcast"]],
  ["datagraphics", ["type:Data Graphics"]],
  ["whitepapers", ["type:Whitepaper"]],
  ["presentations", ["type:Presentation"]],
  ["reports", ["type:Report"]],
  ["webcasts", ["type:Webcast"]]
]);
const categoryFacetKeys = /* @__PURE__ */ new Map([
  [
    "commentaries",
    [
      "categories:BioCentury Commentary",
      "categories:Guest Commentary",
      "categories:Editor's Commentary",
      "categories:Commentaries"
    ]
  ],
  ["databyte", ["categories:Data Byte"]],
  ["deals", ["categories:Deals"]],
  [
    "discoverytranslation",
    [
      "categories:Discovery & Translation",
      "categories:Targets & Mechanisms",
      "categories:Tools & Techniques",
      "categories:Translation in Brief"
    ]
  ],
  ["distillery", ["categories:Distillery Techniques", "categories:Distillery Therapeutics"]],
  ["emergingcompanies", ["categories:Emerging Company Profile"]],
  ["finance", ["categories:Finance", "categories:Financial News"]],
  ["managementtracks", ["categories:Management Tracks"]],
  ["marketaccess", ["categories:Market Access"]],
  [
    "politicspolicylaw",
    [
      "categories:Politics, Policy & Law",
      "categories:Politics & Policy",
      "categories:Politics & Policy News"
    ]
  ],
  ["productdevelopment", ["categories:Product R&D", "categories:Product Development"]],
  ["regulation", ["categories:Regulation"]]
]);
dayjs.extend(customParseFormat);
const BooleanToAlgoliaTerm = (term) => {
  var _a;
  if (term === "")
    return { searchString: term, optionalWords: [] };
  const Words = [];
  let exactSearchWords = [];
  const searchString = term.toString().replace(/AND /g, "").replace(/NOT /g, "-").replace(/OR /g, "").replace(/“|”/g, '"');
  if (term.toString().search(/\sOR\s/) !== -1) {
    const exactRegex = /".*?"/g;
    const spacesRegex = /  +/g;
    exactSearchWords = (_a = term.match(exactRegex)) != null ? _a : [];
    const cleanString = searchString.replace(exactRegex, "").replace(spacesRegex, "");
    cleanString.split(" ").forEach((word) => {
      Words.push(word);
    });
  }
  const optionalWords = compact(concat(Words, exactSearchWords));
  return { searchString, optionalWords };
};
const formatSynonym = ({
  content,
  type,
  synonyms,
  useSearchIndex
}) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    objectID: ((_a = content.code) != null ? _a : content.Code) ? `C${(_b = content.code) != null ? _b : content.Code}` : `${(_c = content.encodedName) != null ? _c : content.EncodedName}-I${(_d = content.id) != null ? _d : content.Id}`,
    type,
    synonyms: synonyms.includes((_e = content.completeName) != null ? _e : content.CompleteName) ? synonyms : concat(synonyms, (_f = content.completeName) != null ? _f : content.CompleteName)
  };
};
const formatContent = ({
  content,
  modelType,
  useSearchIndex
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
  try {
    const {
      __typename,
      id,
      title,
      bodyContent,
      url,
      commentary,
      dealsFilter,
      mobilePinning,
      diseaseCategories,
      targets,
      companies,
      products,
      primarySection,
      authoringDateTime,
      homepageImage,
      bannerImage,
      thumbnail,
      webtitle,
      index,
      articleType,
      authors,
      fieldTags,
      additionalTag,
      articleCategories,
      featuredStory,
      bcxTopStory
    } = content;
    switch (modelType) {
      case ModelType.Article:
        return {
          __typename,
          title,
          url,
          mobilePinning,
          webtitle,
          homepageImage,
          bannerImage,
          thumbnail,
          featuredStory,
          bcxTopStory,
          objectID: hash(`${id}-${index}`),
          referenceId: id,
          description: bodyContent,
          section: primarySection == null ? void 0 : primarySection.name,
          type: (_a = articleType == null ? void 0 : articleType.name) != null ? _a : "Article",
          authoringDateTime: new Date(authoringDateTime != null ? authoringDateTime : null).getTime(),
          companies: compact(companies ? companies == null ? void 0 : companies.map(({ name }) => name) : null),
          targets: compact(targets ? targets == null ? void 0 : targets.map(({ name }) => name) : null),
          diseaseCategories: compact(
            diseaseCategories ? diseaseCategories == null ? void 0 : diseaseCategories.map(({ name }) => name) : null
          ),
          products: compact(products ? products == null ? void 0 : products.map(({ name }) => name) : null),
          tags: compact(
            flatten([
              fieldTags ? fieldTags == null ? void 0 : fieldTags.map(({ name }) => name) : null,
              additionalTag ? additionalTag : null
            ])
          ),
          categories: uniq(
            compact(
              flatten([
                articleCategories ? articleCategories == null ? void 0 : articleCategories.map(({ name }) => name) : null,
                dealsFilter ? "Deals" : null,
                commentary ? "Commentaries" : null
              ])
            )
          ),
          authors: uniq(
            compact(flatten([authors ? authors == null ? void 0 : authors.map(({ authorName }) => authorName) : null]))
          )
        };
      case ModelType.Whitepaper:
        return {
          __typename: ModelType.Article,
          objectID: hash(`${id}`),
          referenceId: id,
          title: content.title,
          webtitle: content.description,
          description: content.summary,
          consentText: content.consentText,
          authors: uniq(compact(flatten([content.author]))),
          tags: compact(flatten([content == null ? void 0 : content.tags.map((name) => name)])),
          homepageImage: (_b = content == null ? void 0 : content.whitepaperImage) != null ? _b : null,
          bannerImage: (_c = content == null ? void 0 : content.whitepaperImage) != null ? _c : null,
          url: (content == null ? void 0 : content.legacyUrl) ? content == null ? void 0 : content.legacyUrl : null,
          authoringDateTime: new Date((_d = content.whitepaperDate) != null ? _d : null).getTime(),
          section: content.primarySection,
          type: "Whitepaper",
          categories: uniq(
            compact(
              flatten([
                (content == null ? void 0 : content.tags) ? content == null ? void 0 : content.tags.map((name) => name) : null,
                content.primarySection ? content.primarySection : null
              ])
            )
          )
        };
      case ModelType.Page:
        return __spreadProps$7(__spreadValues$e({
          __typename: ModelType.Events,
          objectID: content.id,
          title: (_e = content == null ? void 0 : content.headline) != null ? _e : "",
          webtitle: (_f = content == null ? void 0 : content.webtitle) != null ? _f : "",
          url: content.path,
          referenceId: content.id,
          description: content == null ? void 0 : content.description
        }, (content == null ? void 0 : content.contentCardDate) ? {
          authoringDateTime: new Date((_g = content.contentCardDate) != null ? _g : null).getTime()
        } : {}), {
          tags: compact(
            flatten([
              content.people ? content.people : null,
              content.companies ? content.companies : null,
              (content == null ? void 0 : content.fieldTags) ? (_h = content == null ? void 0 : content.fieldTags) == null ? void 0 : _h.map(({ name }) => name) : null,
              (content == null ? void 0 : content.additionalTag) ? content == null ? void 0 : content.additionalTag : null
            ])
          ),
          section: (_j = (_i = content == null ? void 0 : content.section) == null ? void 0 : _i.name) != null ? _j : "Conference",
          thumbnailImage: (_k = content == null ? void 0 : content.thumbnail) != null ? _k : null
        });
      default:
        return __spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e(__spreadValues$e({
          __typename: modelType,
          referenceId: hash(
            `${(_l = content.encodedName) != null ? _l : content.EncodedName}-${(_m = content.code) != null ? _m : content.Code}`
          ),
          objectID: ((_n = content.code) != null ? _n : content.Code) ? `C${(_o = content.code) != null ? _o : content.Code}` : `${(_p = content.encodedName) != null ? _p : content.EncodedName}`,
          dimension: (_q = content.dimension) != null ? _q : content.Dimension,
          completeName: (_r = content.completeName) != null ? _r : content.CompleteName,
          encodedName: (_s = content.encodedName) != null ? _s : content.EncodedName,
          synonyms: (_t = content.synonyms) != null ? _t : content.Synonyms
        }, ((_u = content.name) != null ? _u : content.Name) && {
          name: (_v = content.name) != null ? _v : content.Name
        }), ((_w = content.id) != null ? _w : content.Id) && {
          id: (_x = content.id) != null ? _x : content.Id
        }), content.diseaseCategory && {
          diseaseCategory: (_y = content.diseaseCategory) != null ? _y : content.DiseaseCategory
        }), useSearchIndex ? { title: (_z = content.completeName) != null ? _z : content.CompleteName } : {}), useSearchIndex ? { webtitle: "" } : {}), useSearchIndex ? { section: "BCIQ" } : {}), useSearchIndex ? { isArchived: (_A = content.isArchived) != null ? _A : content.IsArchived } : {}), useSearchIndex ? { authoringDateTime: 0 } : {}), useSearchIndex ? { tags: [(_B = content.completeName) != null ? _B : content.CompleteName] } : {}), modelType === ModelType.Company ? { doingBusinessAs: (_C = content.doingBusinessAs) != null ? _C : content.DoingBusinessAs } : {});
    }
  } catch (error) {
    throw new Error(error);
  }
};
const formatDate = ({
  dataRange,
  startDate,
  endDate
}) => {
  switch (dataRange) {
    case "range" /* RANGE */:
      return [dayjs(startDate, "YYYY-MM-DD").valueOf(), dayjs(endDate, "YYYY-MM-DD").valueOf()];
    case "week" /* WEEK */:
      return [dayjs().subtract(1, "w").valueOf(), dayjs().valueOf()];
    case "month" /* MONTH */:
      return [dayjs().subtract(30, "d").valueOf(), dayjs().valueOf()];
    case "year" /* YEAR */:
      return [dayjs().subtract(1, "y").valueOf(), dayjs().valueOf()];
    default:
      return null;
  }
};
const formatResult = (results) => {
  const companies = [];
  const targets = [];
  const products = [];
  const communities = [];
  const diseases = [];
  const articles = [];
  results.forEach((result) => {
    if (result.__typename === ModelType.Article) {
      articles.push(result);
    }
    if (result.__typename === "Conferences") {
      communities.push(result);
    }
    if (result.__typename === ModelType.Company) {
      companies.push(result);
    }
    if (result.__typename === ModelType.Disease_Category) {
      diseases.push(result);
    }
    if (result.__typename === ModelType.Product) {
      products.push(result);
    }
    if (result.__typename === ModelType.Target) {
      targets.push(result);
    }
  });
  return {
    articles,
    communities,
    companies,
    diseases,
    products,
    targets
  };
};
const formatFacetFilters = (categories, contentType, companies, products, targets, diseaseCategories) => {
  const facetFiltersByType = {
    categories: [],
    companies: [],
    products: [],
    targets: [],
    diseaseCategories: [],
    type: [],
    exclude: []
  };
  const mapFacets = (prefix, item, positiveKeys) => {
    const isNegative = item.charAt(0) === "-";
    const key = (isNegative ? item.substring(1) : item).toString().toLowerCase();
    const filters = positiveKeys ? (positiveKeys == null ? void 0 : positiveKeys.get(key)) || [] : [`${prefix}:${key}`];
    if (isNegative) {
      const negativeFilters = filters.map((filter) => filter.replace(":", ":-"));
      facetFiltersByType.exclude.push(...negativeFilters);
    } else {
      facetFiltersByType[prefix].push(...filters);
    }
  };
  categories == null ? void 0 : categories.forEach((value) => mapFacets("categories", value, categoryFacetKeys));
  companies == null ? void 0 : companies.forEach((value) => mapFacets("companies", value));
  products == null ? void 0 : products.forEach((value) => mapFacets("products", value));
  targets == null ? void 0 : targets.forEach((value) => mapFacets("targets", value));
  diseaseCategories == null ? void 0 : diseaseCategories.forEach((value) => mapFacets("diseaseCategories", value));
  contentType == null ? void 0 : contentType.forEach((value) => mapFacets("type", value, contentTypeFacetKeys));
  const facetFilters = compact(
    Object.keys(facetFiltersByType).reduce((array, key) => {
      const items = facetFiltersByType[key];
      if (key === "exclude") {
        array.push(...items);
      } else {
        array.push(items);
      }
      return array;
    }, [])
  ).filter((item) => item.length);
  return { facetFilters };
};

var __defProp$d = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const createUrl = (state, router) => {
  const query = {};
  query.v = 2;
  if (state.searchTerm) {
    query.q = state.searchTerm;
  }
  const ct = [];
  const hasContentType = Object.values(state.contentTypeFacetKeys).some((value) => value !== null);
  if (hasContentType) {
    Object.keys(state.contentTypeFacetKeys).forEach((key) => {
      const value = state.contentTypeFacetKeys[key];
      if (value === null)
        return;
      if (value) {
        ct.push(key.toLowerCase());
      } else {
        ct.push(`-${key.toLowerCase()}`);
      }
    });
  } else {
    ct.push("all");
  }
  query.ct = ct;
  if (state.dateRange) {
    switch (state.dateRange) {
      case "Any Time" /* ANY */: {
        query.pd = "any";
        break;
      }
      case "Past 7 Days" /* PAST_7_DAYS */: {
        query.pd = "week";
        break;
      }
      case "Past 30 Days" /* PAST_30_DAYS */: {
        query.pd = "month";
        break;
      }
      case "Past 12 Months" /* PAST_12_MONTHS */: {
        query.pd = "year";
        break;
      }
      case "range" /* RANGE */: {
        query.pd = "range";
        query.dateFrom = new Date(state.startDate.toString().split(/\+|-/)[0]).toISOString().split("T")[0];
        query.dateTo = new Date(state.endDate.toString().split(/\+|-/)[0]).toISOString().split("T")[0];
        break;
      }
      default: {
        query.pd = "any";
        break;
      }
    }
  }
  const brs = [];
  const hasCategories = Object.values(state.categoryFacetKeys).some((value) => value !== null);
  if (hasCategories) {
    Object.keys(state.categoryFacetKeys).forEach((key) => {
      const value = state.categoryFacetKeys[key];
      if (value === null)
        return;
      if (value) {
        brs.push(key.toLowerCase());
      } else {
        brs.push(`-${key.toLowerCase()}`);
      }
    });
  } else {
    brs.push("all");
  }
  query.brs = brs;
  if (state.selectedEntities) {
    const cm = [];
    const pr = [];
    const mt = [];
    const dc = [];
    const aut = [];
    state.selectedEntities.map((item) => {
      if (item.type === "Company") {
        cm.push(item.completeName);
      }
      if (item.type === "Product") {
        pr.push(item.completeName);
      }
      if (item.type === "Target") {
        mt.push(item.completeName);
      }
      if (item.type === "Disease Category") {
        dc.push(item.completeName);
      }
      if (item.type === "Author") {
        aut.push(item.completeName);
      }
    });
    if (dc.length > 0) {
      query.dc = dc;
    }
    if (mt.length > 0) {
      query.mt = mt;
    }
    if (pr.length > 0) {
      query.pr = pr;
    }
    if (cm.length > 0) {
      query.cm = cm;
    }
    if (aut.length > 0) {
      query.aut = aut;
    }
  }
  query.aho = state.searchHeadlinesOnly;
  query.pn = Number(state.indexPageNumber);
  query.sort = state.sortBy;
  query.bcx = state.bcxTopStory;
  query.fts = state.featuredStory;
  router.replace({ pathname: "/search", query }, void 0, { shallow: true });
};
const initialNewData = {
  q: "",
  aho: false,
  dateRange: "Any Time" /* ANY */,
  brs: {
    ["all" /* ALL */]: null,
    ["commentaries" /* COMMENTARIES */]: null,
    ["deals" /* DEALS */]: null,
    discoverytranslation: null,
    ["distillery" /* DISTILLERY */]: null,
    emergingcompanies: null,
    ["finance" /* FINANCE */]: null,
    managementtracks: null,
    marketaccess: null,
    politicspolicylaw: null,
    productdevelopment: null,
    ["regulation" /* REGULATION */]: null,
    databyte: null
  },
  ct: {
    ["all" /* ALL */]: null,
    ["Articles" /* ARTICLES */]: null,
    ["Podcasts" /* PODCASTS */]: null,
    ["Datagraphics" /* DATA_GRAPHICS */]: null,
    ["Whitepapers" /* WHITEPAPERS */]: null,
    ["Presentations" /* PRESENTATIONS */]: null,
    ["Reports" /* REPORTS */]: null,
    ["Webcasts" /* WEBCASTS */]: null
  },
  entities: []
};
const useTransformUrlToData = (query) => {
  var _a, _b;
  const resultObj = __spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d(__spreadValues$d({}, initialNewData), Number(query.pn) ? { pn: query.pn } : { pn: 1 }), query.dateFrom && { dateFrom: query.dateFrom }), query.dateTo && { dateTo: query.dateTo }), query.q && { q: query.q }), query.sort && { sortBy: query.sort }), query.aho === "true" ? { aho: true } : { aho: false }), query.bcx === "true" ? { bcx: true } : { bcx: false }), query.fts === "true" ? { fts: true } : { fts: false }), query.pd === "year" && {
    dateRange: "Past 12 Months" /* PAST_12_MONTHS */
  }), query.pd === "month" && {
    dateRange: "Past 30 Days" /* PAST_30_DAYS */
  }), query.pd === "week" && {
    dateRange: "Past 7 Days" /* PAST_7_DAYS */
  }), query.pd === "range" && {
    dateRange: "range" /* RANGE */
  }), Array.isArray(query == null ? void 0 : query.brs) ? {
    brs: __spreadValues$d(__spreadValues$d({}, initialNewData.brs), (_a = query == null ? void 0 : query.brs) == null ? void 0 : _a.reduce((acc, item) => {
      if (item.charAt(0) === "-") {
        acc[item.substring(1)] = false;
      } else {
        acc[item] = true;
      }
      return acc;
    }, {}))
  } : __spreadValues$d({}, typeof query.brs === "string" ? {
    brs: __spreadProps$6(__spreadValues$d(__spreadValues$d({}, initialNewData.brs), new Array(query.brs).reduce((acc, item) => {
      if (item.charAt(0) === "-") {
        acc[item.substring(1)] = false;
      } else {
        acc[item] = true;
      }
      return acc;
    }, {})), {
      all: null
    })
  } : {
    brs: __spreadProps$6(__spreadValues$d({}, initialNewData.brs), {
      all: true
    })
  })), Array.isArray(query == null ? void 0 : query.ct) ? {
    ct: __spreadValues$d(__spreadValues$d({}, initialNewData.ct), (_b = query == null ? void 0 : query.ct) == null ? void 0 : _b.reduce((acc, item) => {
      const capitalize = (item2) => item2 && item2[0].toUpperCase() + item2.slice(1);
      if (item.charAt(0) === "-") {
        acc[capitalize(item.substring(1))] = false;
      } else {
        acc[capitalize(item)] = true;
      }
      return acc;
    }, {}))
  } : __spreadValues$d({}, typeof query.ct === "string" ? {
    ct: __spreadProps$6(__spreadValues$d(__spreadValues$d({}, initialNewData.ct), new Array(query.ct).reduce((acc, item) => {
      const capitalize = (item2) => item2 && item2[0].toUpperCase() + item2.slice(1);
      if (item.charAt(0) === "-") {
        acc[capitalize(item.substring(1))] = false;
      } else {
        acc[capitalize(item)] = true;
      }
      return acc;
    }, {})), {
      all: null
    })
  } : {
    ct: __spreadProps$6(__spreadValues$d({}, initialNewData.ct), {
      all: true
    })
  }));
  if (query.cm) {
    if (Array.isArray(query.cm)) {
      query.cm.map((el) => {
        const companies = {
          type: "Company" /* cm */,
          completeName: el,
          encodedName: el
        };
        resultObj.entities.push(companies);
      });
    }
    if (typeof query.cm === "string") {
      const companies = {
        type: "Company" /* cm */,
        completeName: query.cm,
        encodedName: query.cm
      };
      resultObj.entities.push(companies);
    }
  }
  if (query.pr) {
    if (Array.isArray(query.pr)) {
      query.pr.map((el) => {
        const product = {
          type: "Product" /* pr */,
          completeName: el,
          encodedName: el
        };
        resultObj.entities.push(product);
      });
    }
    if (typeof query.pr === "string") {
      const product = {
        type: "Product" /* pr */,
        completeName: query.pr,
        encodedName: query.pr
      };
      resultObj.entities.push(product);
    }
  }
  if (query.mt) {
    if (Array.isArray(query.mt)) {
      query.mt.map((el) => {
        const target = {
          type: "Target" /* mt */,
          completeName: el,
          encodedName: el
        };
        resultObj.entities.push(target);
      });
    }
    if (typeof query.mt === "string") {
      const target = {
        type: "Target" /* mt */,
        completeName: query.mt,
        encodedName: query.mt
      };
      resultObj.entities.push(target);
    }
  }
  if (query.dc) {
    if (Array.isArray(query.dc)) {
      query.dc.map((el) => {
        const disease = {
          type: "Disease Category" /* dc */,
          completeName: el,
          encodedName: el
        };
        resultObj.entities.push(disease);
      });
    }
    if (typeof query.dc === "string") {
      const disease = {
        type: "Disease Category" /* dc */,
        completeName: query.dc,
        encodedName: query.dc
      };
      resultObj.entities.push(disease);
    }
  }
  if (query.aut) {
    if (Array.isArray(query.aut)) {
      query.aut.map((el) => {
        const author = {
          type: "Author" /* aut */,
          completeName: el,
          encodedName: el
        };
        resultObj.entities.push(author);
      });
    }
    if (typeof query.aut === "string") {
      const author = {
        type: "Author" /* aut */,
        completeName: query.aut,
        encodedName: query.aut
      };
      resultObj.entities.push(author);
    }
  }
  return resultObj;
};

var __defProp$c = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
var __async$r = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let instance$4;
const init$1 = ({ appId, apiKey }) => {
  if (!appId && !instance$4) {
    throw new Error("Algolia APP ID is undefined");
  }
  if (!apiKey && !instance$4) {
    throw new Error("Algolia APP KEY is undefined");
  }
  if (appId && apiKey) {
    instance$4 = algoliasearch(appId, apiKey);
  }
  return instance$4;
};
const parseFromString = (url) => {
  const params = url.replace(/^(.*?\?)/g, "");
  const parsed = queryString.parse(params, {
    parseBooleans: true,
    parseNumbers: true
  });
  return parseFromRoute(parsed);
};
const parseFromRoute = (params) => {
  const data = __spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c(__spreadValues$c({}, (params == null ? void 0 : params.q) && {
    searchTerm: Array.isArray(params.q) ? params.q.join(" ") : params.q
  }), (params == null ? void 0 : params.ct) && {
    contentType: Array.isArray(params.ct) ? params.ct : [params.ct]
  }), (params == null ? void 0 : params.ps) && {
    recordsPerPage: Array.isArray(params.ps) ? params.ps[0] : params.ps
  }), (params == null ? void 0 : params.pn) && {
    pageNumber: Array.isArray(params.pn) ? params.pn[0] : params.pn
  }), (params == null ? void 0 : params.pd) && {
    period: Array.isArray(params.pd) ? params.pd[0] : params.pd
  }), (params == null ? void 0 : params.dateFrom) && {
    dateFrom: Array.isArray(params.dateFrom) ? params.dateFrom[0] : params.dateFrom
  }), (params == null ? void 0 : params.dateTo) && {
    dateTo: Array.isArray(params.dateTo) ? params.dateTo[0] : params.dateTo
  }), (params == null ? void 0 : params.aho) && {
    headlineOnly: Array.isArray(params.aho) ? !!params.aho[0] : !!params.aho
  }), (params == null ? void 0 : params.bcx) && {
    bcxTopStory: Array.isArray(params.bcx) ? !!params.bcx[0] : !!params.bcx
  }), (params == null ? void 0 : params.fts) && {
    featuredStory: Array.isArray(params.fts) ? !!params.fts[0] : !!params.fts
  }), (params == null ? void 0 : params.brs) && {
    categories: Array.isArray(params.brs) ? params.brs : [params.brs]
  }), (params == null ? void 0 : params.cm) && {
    company: Array.isArray(params.cm) ? params.cm : [params.cm]
  }), (params == null ? void 0 : params.pr) && {
    product: Array.isArray(params.pr) ? params.pr : [params.pr]
  }), (params == null ? void 0 : params.mt) && {
    molecular: Array.isArray(params.mt) ? params.mt : [params.mt]
  }), (params == null ? void 0 : params.dc) && {
    disease: Array.isArray(params.dc) ? params.dc : [params.dc]
  }), (params == null ? void 0 : params.aut) && {
    authors: Array.isArray(params.aut) ? params.aut : [params.aut]
  }), (params == null ? void 0 : params.sort) && {
    sort: Array.isArray(params.sort) ? params.sort[0] : params.sort
  });
  return createQuery(data);
};
const createQuery = ({
  searchTerm,
  contentType,
  pageNumber,
  recordsPerPage,
  period,
  dateFrom,
  dateTo,
  headlineOnly,
  bcxTopStory,
  featuredStory,
  categories,
  company,
  product,
  molecular,
  disease,
  authors,
  sort
}) => {
  const SEARCH_INDEX_OLDEST_SORT = `${process.env.NEXT_PUBLIC_ALGOLIA_ARTICLE_INDEX_NAME}_oldest_sort`;
  const SEARCH_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_ARTICLE_INDEX_NAME || "";
  const entitiesFromUrl = compact([
    ...company || [],
    ...product || [],
    ...molecular || [],
    ...disease || []
  ]);
  const entities = entitiesFromUrl == null ? void 0 : entitiesFromUrl.map((each) => {
    const entity = `"${each}"`;
    return entity;
  });
  const authorsFromUrl = compact([...authors || []]);
  const authorsEntities = authorsFromUrl == null ? void 0 : authorsFromUrl.map((each) => {
    const author = `"${each}"`;
    return author;
  });
  const completeEntities = [...entities, ...authorsEntities];
  const isEntities = !!completeEntities.length;
  const date = formatDate(__spreadValues$c(__spreadValues$c({
    dataRange: period || "any"
  }, dateFrom && { startDate: dateFrom }), dateTo && { endDate: dateTo }));
  const { searchString, optionalWords } = BooleanToAlgoliaTerm(
    isEntities ? `${searchTerm ? `${searchTerm} OR ` : ""}${completeEntities.join(" OR ")}` : searchTerm || ""
  );
  let filters = "";
  if (date)
    filters += ` AND authoringDateTime:${date[0]} TO ${date[1]}`;
  if (bcxTopStory)
    filters += ` AND bcxTopStory:${bcxTopStory}`;
  if (featuredStory)
    filters += ` AND featuredStory:${featuredStory}`;
  filters = filters.substring(5);
  const generatedQuery = {
    query: searchString,
    params: __spreadProps$5(__spreadValues$c(__spreadValues$c(__spreadProps$5(__spreadValues$c({}, optionalWords && { optionalWords }), {
      advancedSyntax: true,
      facets: ["*", "__typename", "authoringDateTime", "section", "categories"]
    }), formatFacetFilters(categories, contentType)), headlineOnly && {
      restrictSearchableAttributes: ["title"]
    }), {
      page: Number(pageNumber) - 1 || 0,
      hitsPerPage: Number(recordsPerPage) || 20,
      filters
    }),
    indexName: (sort == null ? void 0 : sort.includes("Oldest First")) ? SEARCH_INDEX_OLDEST_SORT : SEARCH_INDEX
  };
  return generatedQuery;
};
const query = (_0) => __async$r(void 0, [_0], function* ({
  indexName,
  options,
  client = instance$4,
  appId,
  apiKey
}) {
  let searchClient = client;
  if (!searchClient) {
    searchClient = init$1({ appId, apiKey });
  }
  const { results } = yield searchClient.search([
    __spreadValues$c({
      indexName
    }, options)
  ]);
  return {
    data: formatResult(results[0].hits),
    nbHits: results[0].nbHits,
    nbPages: results[0].nbPages,
    page: results[0].page
  };
});

const Algolia = {
  saveObject,
  saveSynonym,
  saveSynonyms,
  saveObjects,
  deleteObject,
  formatContent,
  formatSynonym,
  formatResult,
  clearObjects,
  findObject,
  search,
  deleteObjects,
  deleteBy,
  init: init$1,
  query,
  parseFromRoute,
  parseFromString,
  createUrl,
  useTransformUrlToData
};

var __async$q = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const constants = {
  accessTokenKey: "SESSa",
  refreshTokenKey: "SESSr",
  rememberMeKey: "SESSs",
  yearInSeconds: 365 * 24 * 60 * 60
};
const isLoggedIn = () => !!parseCookies().SESSa;
const isIpUser = () => ["IpUser", "Combined"].includes(property("user_type"));
const isRegularUser = () => ["User", "Combined"].includes(property("user_type"));
const userId = () => property("sub") || "anonymous";
const userEntitlements = (entitlementType) => {
  const propertyName = entitlementType === "paid" ? "roles" : "trial_data";
  const data = property(propertyName);
  if (!data || !data.length) {
    return;
  }
  if (!Array.isArray(data)) {
    return data;
  }
  return data.join("|");
};
const remainingTrialDays = () => {
  const trialEntitlements = userEntitlements("trial");
  if (!trialEntitlements) {
    return "";
  }
  const entitlementsList = trialEntitlements.split("|");
  if (!entitlementsList || !entitlementsList.length) {
    return "";
  }
  const result = entitlementsList.map((entitlement) => {
    const items = entitlement.split(".");
    const productName = items[0];
    const registerDate = items[1].split("_");
    if (productName && (registerDate == null ? void 0 : registerDate.length) > 2) {
      const startDate = new Date(registerDate[1]);
      const { days } = DateTime.now().diff(DateTime.fromJSDate(startDate), "days");
      return `${productName}:Day ${days}`;
    }
  });
  return result.filter((item) => item).join(",");
};
const property = (name) => {
  try {
    if (!isLoggedIn()) {
      return;
    }
    const accessToken = JWTDecode(parseCookies().SESSa);
    return accessToken[name];
  } catch (error) {
    console.error(error);
  }
};
const isAccessTokenExpired = (accessToken) => {
  const JWT = JWTDecode(accessToken);
  const now = DateTime.local().minus({ minutes: 1 });
  const expiration = DateTime.fromMillis(JWT.exp * 1e3);
  const isExpired = expiration <= now;
  return isExpired;
};
const refreshAccessToken = (_0, ..._1) => __async$q(void 0, [_0, ..._1], function* (context, contextType = ContextType.Nextjs) {
  var _a, _b;
  try {
    if (isEmpty(context))
      return;
    let refreshToken;
    if (contextType === ContextType.Nextjs) {
      refreshToken = nookies.get(context).SESSr;
    }
    if (contextType === ContextType.Azure) {
      refreshToken = (_a = context.req) == null ? void 0 : _a.headers.sessr;
    }
    const rawResponse = yield fetch(
      `${(_b = process.env.BIOCENTURY_IDENTITY_API_URL) != null ? _b : process.env.NEXT_PUBLIC_BIOCENTURY_IDENTITY_API_URL}/api/User/refresh-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(refreshToken)
      }
    );
    const response = yield rawResponse.json();
    if (!response.success) {
      nookies.destroy(context, constants.accessTokenKey, {
        path: "/",
        domain: process.env.BIOCENTURY_DOMAIN
      });
      nookies.destroy(context, constants.refreshTokenKey, {
        path: "/",
        domain: process.env.BIOCENTURY_DOMAIN
      });
    } else if (response) {
      if (contextType === ContextType.Nextjs && context.req.headers.host) {
        const expires = new Date();
        expires.setUTCFullYear(expires.getUTCFullYear() + 2);
        nookies.set(context, constants.accessTokenKey, response.accessToken, {
          secure: true,
          expires,
          path: "/",
          domain: process.env.BIOCENTURY_DOMAIN
        });
        nookies.set(context, constants.refreshTokenKey, response.refreshToken, {
          secure: true,
          expires,
          path: "/",
          domain: process.env.BIOCENTURY_DOMAIN
        });
      }
      return response.accessToken;
    }
  } catch (error) {
    console.error("Error refreshing access token - ", error);
  }
});
const getClientSideCookie = (name) => Cookies.get(name);
const Credentials = {
  isLoggedIn,
  isIpUser,
  isRegularUser,
  userId,
  userEntitlements,
  remainingTrialDays,
  property,
  getClientSideCookie,
  isAccessTokenExpired,
  refreshAccessToken
};

const instance$3 = () => {
  if (typeof window !== "undefined") {
    return window;
  }
};
const stringToDocument = (content) => {
  return new DOMParser().parseFromString(content, "text/html");
};
const Window = { instance: instance$3, stringToDocument };

const instance$2 = () => {
  const window = Window.instance();
  return window && window.dataLayer;
};
const track$1 = (event) => {
  var _a, _b;
  const dataLayer = instance$2();
  if (!dataLayer) {
    return;
  }
  const { action, category, name, articleData, articleIds } = event;
  const paidEntitlements = Credentials.userEntitlements("paid");
  const trialEntitlements = Credentials.userEntitlements("trial");
  const context = {
    event: name || action,
    "bc-category": category,
    "bc-action": "click",
    UserID: Credentials.property("sub") || "<None>",
    CompanyName: ((_a = Credentials.property("customClaims")) == null ? void 0 : _a.company) || "<None>",
    CompanyID: Credentials.property("tenantId") || "<None>",
    LoginStatus: Credentials.isLoggedIn() ? "Yes" : "No",
    PaidEntitlementStatus: !!paidEntitlements,
    PaidEntitlements: paidEntitlements || "<None>",
    TrialEntitlementStatus: !!trialEntitlements,
    TrialEntitlements: trialEntitlements || "<None>",
    ArticleID: "<None>",
    Headline: "<None>",
    Authors: "<None>",
    PubDate: "<None>",
    Category: "<None>",
    ArticleTags: "<None>",
    PageEntitlement: "<None>",
    SSOStatus: ((_b = Credentials.property("customClaims")) == null ? void 0 : _b.creationSource.label) === "SSOSaml" ? "Yes" : "No"
  };
  if (articleData) {
    assign(context, articleData);
  }
  if (articleIds) {
    assign(context, { articleIds });
  }
  const pageViewEntry = context.event === "pageview" && Array.isArray(dataLayer) && dataLayer.find((entry) => typeof entry === "object" && entry.event === "pageview");
  if (pageViewEntry) {
    Object.assign(pageViewEntry, context);
  } else {
    dataLayer.push(context);
  }
};
const GoogleAnalytics = { instance: instance$2, track: track$1 };

const script$3 = () => {
  const accountId = process.env.NEXT_PUBLIC_GTM_TRACKING_ID;
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
            'gtm.start': new Date().getTime(),event:'gtm.js'
          });var f=d.getElementsByTagName(s)[0],j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f); })(
            window, document, 'script',
            'dataLayer', '${accountId}'
          );`;
};
const iframe = () => {
  const accountId = process.env.NEXT_PUBLIC_GTM_TRACKING_ID;
  return `<iframe src="https://www.googletagmanager.com/ns.html?id=${accountId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
};
const GoogleTagManager = { script: script$3, iframe };

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __async$p = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const instance$1 = () => {
  const window = Window.instance();
  return window && window.amplitude;
};
const logEvent$1 = (event) => __async$p(void 0, null, function* () {
  const amplitude = instance$1();
  if (!amplitude) {
    return;
  }
  amplitude.logEvent(event.eventType, __spreadValues$b({
    userId: event.userId
  }, event.eventProperties));
});
const script$2 = () => {
  const accountId = process.env.NEXT_PUBLIC_AMPLITUDE_APP_ID;
  const userId = Credentials.userId();
  const email = Credentials.property("email") || "";
  const givenName = Credentials.property("given_name") || "";
  const familyName = Credentials.property("family_name") || "";
  const name = `${givenName} ${familyName}`;
  const isInternal = /@biocentury\.com$/.test(email);
  return `
  (function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
  ;r.type="text/javascript"
  ;r.integrity="sha384-u0hlTAJ1tNefeBKwiBNwB4CkHZ1ck4ajx/pKmwWtc+IufKJiCQZ+WjJIi+7C6Ntm"
  ;r.crossOrigin="anonymous";r.async=true
  ;r.src="https://cdn.amplitude.com/libs/amplitude-8.1.0-min.gz.js"
  ;r.onload=function(){if(!e.amplitude.runQueuedFunctions){
  console.log("[Amplitude] Error: could not load SDK")}}
  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
  ;function s(e,t){e.prototype[t]=function(){
  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
  var o=function(){this._q=[];return this}
  ;var a=["add","append","clearAll","prepend","set","setOnce","unset","preInsert","postInsert","remove"]
  ;for(var c=0;c<a.length;c++){s(o,a[c])}n.Identify=o;var u=function(){this._q=[]
  ;return this}
  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
  ;for(var p=0;p<l.length;p++){s(u,l[p])}n.Revenue=u
  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","enableTracking","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","groupIdentify","onInit","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
  ;function v(e){function t(t){e[t]=function(){
  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
  ;if(!Object.prototype.hasOwnProperty.call(n._iq,e)){n._iq[e]={_q:[]};v(n._iq[e])
  }return n._iq[e]};e.amplitude=n})(window,document);

  var instance = amplitude.getInstance();
  var identify = new amplitude.Identify()
                              .set('id', '${userId}')
                              .set('name', '${name}')
                              .set('internal', '${isInternal}');

  instance.init('${accountId}');
  instance.identify(identify);
  `;
};
const AmplitudeAnalytics = { logEvent: logEvent$1, instance: instance$1, script: script$2 };

isbot.extend(["Applebot"]);
function instance() {
  const window = Window.instance();
  return window == null ? void 0 : window.analytics;
}
function logEvent(event) {
  var _a;
  if (isbot((_a = Window.instance()) == null ? void 0 : _a.navigator.userAgent)) {
    return;
  }
  const segment = instance();
  if (!segment) {
    return;
  }
  const hasUser = identifyUser();
  if (!hasUser) {
    return;
  }
  segment.track(event.type, event.properties);
}
function identifyUser() {
  const segment = instance();
  const segmentUser = Cookies.get("ajs_user_id");
  const userId = Credentials.userId();
  const hasUser = userId !== "anonymous";
  const email = Credentials.property("email") || "";
  const givenName = Credentials.property("given_name") || "";
  const familyName = Credentials.property("family_name") || "";
  const name = `${givenName} ${familyName}`;
  const internal = /@biocentury\.com$/.test(email);
  if (hasUser && userId !== segmentUser) {
    segment == null ? void 0 : segment.identify(userId, {
      id: userId,
      name,
      internal
    });
  }
  return hasUser;
}
function page() {
  var _a;
  if (isbot((_a = Window.instance()) == null ? void 0 : _a.navigator.userAgent)) {
    return;
  }
  const segment = instance();
  if (!segment) {
    return;
  }
  identifyUser();
  segment.page();
}
function script$1({ segmentWriteKey }) {
  return `
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${segmentWriteKey}";analytics.SNIPPET_VERSION="4.15.3";
    analytics.load("${segmentWriteKey}");
    }}();
  `;
}
const SegmentAnalytics = { script: script$1, instance, identifyUser, page, logEvent };

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
const track = (event) => {
  var _a;
  const allowAnalyticsTracking = Credentials.property("no_stat") !== true;
  if (!allowAnalyticsTracking) {
    return;
  }
  const window = Window.instance();
  const pushEvent = window && ((_a = window == null ? void 0 : window.bc) == null ? void 0 : _a.push);
  if (!pushEvent) {
    return;
  }
  if (event.action) {
    const userId = Credentials.userId();
    const context = {
      user_id: userId,
      product: event.product || "BioCentury"
    };
    if (SegmentAnalytics.instance()) {
      SegmentAnalytics.logEvent({
        type: event.action,
        properties: __spreadValues$a({
          product: event.product || Product.BioCentury,
          url: event.url,
          path: event.path,
          category: event.category,
          articleData: event.articleData
        }, event.properties)
      });
    } else if (AmplitudeAnalytics.instance()) {
      AmplitudeAnalytics.logEvent({
        userId,
        eventType: event.action,
        eventProperties: __spreadValues$a({
          product: event.product || Product.BioCentury,
          url: event.url,
          path: event.path,
          category: event.category,
          articleData: event.articleData
        }, event.properties)
      });
    }
    pushEvent(`${event.action}:${event.category}`, context);
  }
};
const script = () => {
  return `
    var __gifUrl = 'https://core-biocentury-com.biomarinproxy01.infotrieve.com/Webusage/Statistics/stat.gif';
		var bc = bc || [];

    (function(s) {
      function Runner() {
        // private members:
        var createImage = function(url) {
          var image = new Image(1, 1);
          image.src = url;
        },
        isNullOrEmpty = function(s) {
          return !s || s.trim().length === 0;
        },
        getQuery = function(action, container) {
          var res = '?';
          url = container && container.url ? container.url : '';
          url = (url && url.length > 0) ? url : window.location.href;
          //
          var devicePixelRatio = window.devicePixelRatio || 1;
          var screenSize = screen.width * devicePixelRatio + 'x' + screen.height * devicePixelRatio;
          //
          res += !isNullOrEmpty(url) ? '&_url=' + encodeURIComponent(url) : '';
          res += !isNullOrEmpty(container.product) ? '&product=' + encodeURIComponent(container.product) : '';
          res += !isNullOrEmpty(container.user_id) ? '&user_id=' + encodeURIComponent(container.user_id) : '';
          res += !isNullOrEmpty(container.customer_id) ? '&customer_id=' + encodeURIComponent(container.customer_id) : '';
          res += '&screen=' + screenSize
          res += '&action=' + encodeURIComponent(action);
          res += '&hash=' + new Date().getTime();
          return res;
        };
        return {
          // public methods:
          __default: function(action, container) {
              if (typeof window.__gifUrl === "undefined") {
                  window.__gifUrl = 'http://newbc02.dnsalias.net/WebUsage/Statistics/stat.gif';
              }
              if (!container) {
                console.log('Container is absent');
                return;
              }
              createImage(window.__gifUrl + getQuery(action, container));
          }
        }
      };
      var runner = new Runner();
      // execute current methods:
      runner['__default'].apply(runner, [bc[0], bc[1]]);
      //
      function apply() {
          runner['__default'].apply(runner, [arguments[0], arguments[1]]);
      }
      function BcProxy() {
        return {
          push: apply
          };
      }
      // replace array with proxy object:
      bc = new BcProxy();
    })('it works!');
  `;
};
const WebUsage = { track, script };

const Analytics = {
  AmplitudeAnalytics,
  GoogleAnalytics,
  GoogleTagManager,
  WebUsage,
  SegmentAnalytics
};

var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __async$o = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _a;
const domains = {
  [FetchAPI.DEFAULT]: (_a = process.env.BIOCENTURY_API_URL) != null ? _a : process.env.NEXT_PUBLIC_BIOCENTURY_API_URL,
  [FetchAPI.ARTICLE]: process.env.BIOCENTURY_ARTICLE_API_URL,
  [FetchAPI.IDENTITY]: process.env.BIOCENTURY_IDENTITY_API_URL,
  [FetchAPI.ALERT]: process.env.BIOCENTURY_ALERT_URL
};
const getToken = (context) => {
  var _a2, _b, _c, _d, _e;
  let accessToken;
  if (isEmpty(context)) {
    return accessToken;
  }
  accessToken = ((_c = (_b = (_a2 = context == null ? void 0 : context.req) == null ? void 0 : _a2.headers) == null ? void 0 : _b.authorization) == null ? void 0 : _c.replace("Bearer ", "")) || ((_e = (_d = context == null ? void 0 : context.req) == null ? void 0 : _d.headers) == null ? void 0 : _e.sessa) || parseCookies().SESSa || nookies.get(context).SESSa;
  return accessToken;
};
const fetcher$3 = (_0) => __async$o(void 0, [_0], function* ({
  endpoint,
  context,
  api = FetchAPI.DEFAULT,
  method = RestMethods.GET,
  contextType = ContextType.Nextjs,
  body
}) {
  const url = `${domains[api]}${endpoint}`;
  let accessToken = getToken(context);
  if (accessToken && isAccessTokenExpired(accessToken)) {
    const freshToken = yield refreshAccessToken(context, contextType);
    if (freshToken) {
      accessToken = freshToken;
    }
  }
  return fetch$2(url, __spreadValues$9({
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "X-API-KEY": process.env.X_API_KEY
    }
  }, body && {
    body
  }));
});
const fetcherJSON$1 = (params) => __async$o(void 0, null, function* () {
  const { contextType, context } = params;
  const response = yield fetcher$3(params);
  const json = yield response.json();
  if (contextType === ContextType.Azure) {
    context.log.info("Logging json object");
    context.log.info({ json: JSON.stringify(json, null, 2) });
  }
  if (json.errors) {
    throw new Error("Failed to fetch API");
  }
  return json;
});

var __async$n = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$7 = {
  getArticle: (id) => `/search/v1/articles/${id}`,
  getChunksArticle: (id) => `/api/algolia/getchunks?LegacyId=${id}`
};
const getArticle = (input) => __async$n(void 0, null, function* () {
  const { context, id } = input;
  const content = yield fetcherJSON$1({
    endpoint: endpoints$7.getArticle(id),
    context,
    api: FetchAPI.ARTICLE
  });
  return content;
});
const getChunksArticle = (input) => __async$n(void 0, null, function* () {
  const { context, id } = input;
  const content = yield fetcherJSON$1({
    endpoint: endpoints$7.getChunksArticle(id),
    context,
    api: FetchAPI.ARTICLE
  });
  return content;
});
const ArticleAPI = { getArticle, getChunksArticle };

var __async$m = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchFilterSetByIds = (_0) => __async$m(void 0, [_0], function* ({ ids, context }) {
  return Promise.all(
    ids.map((id) => __async$m(void 0, null, function* () {
      const response = yield fetcher$3({
        endpoint: `/api/UserSettings/filterSet/${id}`,
        context,
        method: RestMethods.GET
      });
      if (response.status === 200) {
        return response.json();
      }
      return {};
    }))
  );
});
const fetchBookmarksByIds = (_0) => __async$m(void 0, [_0], function* ({ ids, context }) {
  return Promise.all(
    ids.map((id) => __async$m(void 0, null, function* () {
      const response = yield fetcher$3({
        endpoint: `/api/UserSettings/bookmarks/${id}`,
        context,
        method: RestMethods.GET
      });
      if (response.status === 200) {
        return response.json();
      }
      return {};
    }))
  );
});
const BCIQ = {
  fetchFilterSetByIds,
  fetchBookmarksByIds
};

var __async$l = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$6 = {
  getCompanies: ({
    pageNumber,
    pageSize,
    orderBy = "dateCreated",
    orderType = "descending"
  }) => {
    const params = stringify({
      pageSize,
      pageNumber,
      orderBy,
      orderType
    });
    return `/search/v1/entityfetch/company?${params}`;
  },
  getCompany: (id) => `/search/v1/entityfetch/company/bycode?code=${id}`,
  searchCompanies: (input) => `/search/v1/profile/company/suggest/${input}?pagesize=200&context=company`
};
const getCompanies$1 = (input) => __async$l(void 0, null, function* () {
  const { context, pageSize, pageNumber, contextType } = input;
  const { Items } = yield fetcherJSON$1({
    endpoint: endpoints$6.getCompanies({ pageSize, pageNumber }),
    context,
    contextType
  });
  if (Items === null || typeof Items === "undefined" || !Object.keys(Items)) {
    throw new Error("Company items is null/empty/undefined");
  }
  return Items;
});
const searchCompanies = (input) => __async$l(void 0, null, function* () {
  const { items = null } = yield fetcherJSON$1({
    endpoint: endpoints$6.searchCompanies(input),
    context: {}
  });
  if (!items)
    return [];
  return items;
});
const getCompany = (input) => __async$l(void 0, null, function* () {
  const { context, id, contextType } = input;
  const { Item } = yield fetcherJSON$1({
    endpoint: endpoints$6.getCompany(id),
    context,
    contextType
  });
  if (Item === null || typeof Item === "undefined" || !Object.keys(Item)) {
    throw new Error("Company Item is null/empty/undefined");
  }
  return Item;
});
const CompanyAPI = { getCompanies: getCompanies$1, getCompany, searchCompanies };

var __async$k = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$5 = {
  getDiseases: ({
    pageNumber,
    pageSize,
    orderBy,
    orderType
  }) => {
    const params = stringify({
      pageSize,
      pageNumber,
      orderBy,
      orderType
    });
    return `/search/v1/entityfetch/diseasecategoryandstandardindication?${params}`;
  },
  getDisease: (id, dimension) => `/search/v1/entityfetch/diseasecategoryandstandardindication/byid?id=${id}&dimension=${dimension}`,
  searchDiseases: (input) => `/search/v1/profile/diseasecategoryandstandardindication/suggest/${input}?pagesize=200&context=diseasecategoryandstandardindication`
};
const getDiseases = (input) => __async$k(void 0, null, function* () {
  const { context, pageSize, pageNumber, contextType } = input;
  const { Items } = yield fetcherJSON$1({
    endpoint: endpoints$5.getDiseases({ pageSize, pageNumber }),
    context,
    contextType
  });
  if (Items === null || typeof Items === "undefined" || !Object.keys(Items)) {
    throw new Error("Disease item is null/empty/undefined");
  }
  return Items;
});
const searchDiseases = (input) => __async$k(void 0, null, function* () {
  const { items = null } = yield fetcherJSON$1({
    endpoint: endpoints$5.searchDiseases(input),
    context: {}
  });
  if (!items)
    return [];
  return items;
});
const getDisease = (input) => __async$k(void 0, null, function* () {
  const { context, id, dimension, contextType } = input;
  const { Item } = yield fetcherJSON$1({
    endpoint: endpoints$5.getDisease(id, dimension),
    context,
    contextType
  });
  if (Item === null || typeof Item === "undefined" || !Object.keys(Item)) {
    throw new Error("Disease Item is null/empty/undefined");
  }
  return Item;
});
const DiseaseAPI = { getDisease, getDiseases, searchDiseases };

var __async$j = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$4 = {
  folders: () => "/myworkspace/folders",
  folder: (folderId) => `/myworkspace/folder/${folderId}`,
  createFolder: (name) => `/myworkspace/folder?folderName=${name}`,
  renameFolder: (folderId, name) => `/myworkspace/folder/${folderId}?newFolderName=${name}`,
  deleteFolder: (folderId) => `/myworkspace/folder/${folderId}`,
  addItem: (folderId) => `/myworkspace/folder/${folderId}/gcmsitem`,
  addFilterSet: (folderId, id, name) => `/myworkspace/folder/${folderId}/filterset?id=${id}&name=${name}`,
  removeItem: (folderId, id) => `/myworkspace/folder/${folderId}/item/${id}`,
  addSearch: () => `/myworkspace/savedsearch`,
  updateSearch: (id) => `/myworkspace/savedsearch/${id}`,
  deleteSearch: (id) => `/myworkspace/savedsearch/${id}`,
  alerts: () => "/alert/card",
  readAlert: () => "/alert/isread"
};
const folders = (_0) => __async$j(void 0, [_0], function* ({ context }) {
  return fetcher$3({
    endpoint: endpoints$4.folders(),
    context
  });
});
const createFolder = (_0) => __async$j(void 0, [_0], function* ({
  context,
  name
}) {
  return fetcher$3({
    endpoint: endpoints$4.createFolder(name),
    context,
    method: RestMethods.POST
  });
});
const renameFolder = (_0) => __async$j(void 0, [_0], function* ({
  context,
  id,
  name
}) {
  return fetcher$3({
    endpoint: endpoints$4.renameFolder(id, name),
    context,
    method: RestMethods.PUT
  });
});
const deleteFolder = (_0) => __async$j(void 0, [_0], function* ({ context, id }) {
  return fetcher$3({
    endpoint: endpoints$4.deleteFolder(id),
    context,
    method: RestMethods.DELETE
  });
});
const addItem = (_0) => __async$j(void 0, [_0], function* ({
  context,
  type,
  id,
  name,
  url,
  folder
}) {
  return fetcher$3({
    endpoint: endpoints$4.addItem(folder),
    context,
    method: RestMethods.POST,
    body: JSON.stringify({
      type,
      name: id,
      content: {
        id,
        title: name,
        url
      }
    })
  });
});
const addFilterSet = (_0) => __async$j(void 0, [_0], function* ({
  context,
  id,
  name,
  folder
}) {
  return fetcher$3({
    endpoint: endpoints$4.addFilterSet(folder, id, name),
    context,
    method: RestMethods.PUT
  });
});
const removeItem = (_0) => __async$j(void 0, [_0], function* ({
  context,
  id,
  folder
}) {
  return fetcher$3({
    endpoint: endpoints$4.removeItem(folder, id),
    context,
    method: RestMethods.DELETE
  });
});
const addSearch = (_0) => __async$j(void 0, [_0], function* ({
  context,
  name,
  searchString,
  isDaily,
  isWeekly,
  isMyFeed
}) {
  return fetcher$3({
    endpoint: endpoints$4.addSearch(),
    context,
    method: RestMethods.POST,
    body: JSON.stringify({
      searchString,
      name,
      isDaily,
      isWeekly,
      isMyFeed
    })
  });
});
const updateSearch = (_0) => __async$j(void 0, [_0], function* ({
  context,
  id,
  name,
  searchString,
  isDaily,
  isWeekly,
  isMyFeed
}) {
  return fetcher$3({
    endpoint: endpoints$4.updateSearch(id),
    context,
    method: RestMethods.PUT,
    body: JSON.stringify({
      searchString,
      name,
      isDaily,
      isWeekly,
      isMyFeed
    })
  });
});
const deleteSearch = (_0) => __async$j(void 0, [_0], function* ({ context, id }) {
  return fetcher$3({
    endpoint: endpoints$4.deleteSearch(id),
    context,
    method: RestMethods.DELETE
  });
});
const alerts = (context) => __async$j(void 0, null, function* () {
  return fetcher$3({
    endpoint: endpoints$4.alerts(),
    context,
    api: FetchAPI.ALERT,
    method: RestMethods.GET
  });
});
const readAlert = (_0) => __async$j(void 0, [_0], function* ({
  context,
  alertIds,
  cardId,
  isRead
}) {
  return fetcher$3({
    endpoint: endpoints$4.readAlert(),
    context,
    body: JSON.stringify({
      alertIds,
      cardId,
      isRead,
      alertType: "savedsearch"
    }),
    api: FetchAPI.ALERT,
    method: RestMethods.POST
  });
});
const MyWorkspaceAPI = {
  folders,
  createFolder,
  renameFolder,
  deleteFolder,
  addItem,
  addFilterSet,
  removeItem,
  addSearch,
  updateSearch,
  deleteSearch,
  alerts,
  readAlert
};

var __async$i = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$3 = {
  reportByName: (reportName) => `/api/AppSettings/reportConfig/${reportName}`,
  reportById: (reportId, workSpaceId) => `/api/PBIReport/GetReportById/${reportId}/${workSpaceId}/view`
};
const reportByName = (_0) => __async$i(void 0, [_0], function* ({
  context,
  reportName
}) {
  return fetcher$3({
    endpoint: endpoints$3.reportByName(reportName),
    context
  });
});
const reportById = (_0) => __async$i(void 0, [_0], function* ({
  context,
  reportId,
  workspaceId
}) {
  return fetcher$3({
    endpoint: endpoints$3.reportById(reportId, workspaceId),
    context
  });
});
const PowerBIAPI = {
  reportByName,
  reportById
};

var __async$h = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$2 = {
  getProducts: ({
    pageNumber,
    pageSize,
    orderBy,
    orderType
  }) => {
    const params = stringify({
      pageSize,
      pageNumber,
      orderBy,
      orderType
    });
    return `/search/v1/entityfetch/product?${params}`;
  },
  getProduct: (id) => `/search/v1/entityfetch/product/byid?id=${id}`,
  searchProducts: (input) => `/search/v1/profile/product/suggest/${input}?pagesize=200&context=product`
};
const getProducts = (input) => __async$h(void 0, null, function* () {
  const { context, pageSize, pageNumber, contextType } = input;
  const { Items } = yield fetcherJSON$1({
    endpoint: endpoints$2.getProducts({ pageSize, pageNumber }),
    context,
    contextType
  });
  if (Items === null || typeof Items === "undefined" || !Object.keys(Items)) {
    throw new Error("Product itema is null/empty/undefined");
  }
  return Items;
});
const getProduct = (input) => __async$h(void 0, null, function* () {
  const { context, id, contextType } = input;
  const { Item } = yield fetcherJSON$1({
    endpoint: endpoints$2.getProduct(id),
    context,
    contextType
  });
  if (Item === null || typeof Item === "undefined" || !Object.keys(Item)) {
    throw new Error("Product item is null/empty/undefined");
  }
  return Item;
});
const searchProducts = (input) => __async$h(void 0, null, function* () {
  const { items = null } = yield fetcherJSON$1({
    endpoint: endpoints$2.searchProducts(input),
    context: {}
  });
  if (!items)
    return [];
  return items;
});
const ProductAPI = { getProducts, getProduct, searchProducts };

var __async$g = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints$1 = {
  getTargets: ({
    pageNumber,
    pageSize,
    orderBy,
    orderType
  }) => {
    const params = stringify({
      pageSize,
      pageNumber,
      orderBy,
      orderType
    });
    return `/search/v1/entityfetch/moleculartargetandfamily?${params}`;
  },
  getTarget: (id, dimension) => `/search/v1/entityfetch/moleculartargetandfamily/byid?id=${id}&dimension=${dimension}`,
  getTargetEncodedName: (name) => `/search/v1/EntityFetch/moleculartargetandfamily/byname?name=${name}`,
  searchTarget: (input) => `/search/v1/profile/moleculartargetandfamily/suggest/${input}?pagesize=200&context=moleculartargetandfamily`
};
const getTargets = (input) => __async$g(void 0, null, function* () {
  const { context, pageSize, pageNumber, contextType } = input;
  const { Items } = yield fetcherJSON$1({
    endpoint: endpoints$1.getTargets({ pageSize, pageNumber }),
    context,
    contextType
  });
  if (Items === null || typeof Items === "undefined" || !Object.keys(Items)) {
    throw new Error("Target items is null/empty/undefined");
  }
  return Items;
});
const searchTargets = (input) => __async$g(void 0, null, function* () {
  const { items = null } = yield fetcherJSON$1({
    endpoint: endpoints$1.searchTarget(input),
    context: {}
  });
  if (!items)
    return [];
  return items;
});
const getTarget = (input) => __async$g(void 0, null, function* () {
  const { context, id, dimension, contextType } = input;
  const { Item } = yield fetcherJSON$1({
    endpoint: endpoints$1.getTarget(id, dimension),
    context,
    contextType
  });
  if (Item === null || typeof Item === "undefined" || !Object.keys(Item)) {
    throw new Error("Target item is null/empty/undefined");
  }
  return Item;
});
const getTargetEncodedName = (input) => __async$g(void 0, null, function* () {
  const { context, contextType, name } = input;
  const { Items } = yield fetcherJSON$1({
    endpoint: endpoints$1.getTargetEncodedName(encodeURIComponent(name)),
    context,
    contextType
  });
  return Items.length === 0 ? null : Items[0].EncodedName;
});
const TargetAPI = {
  getTargets,
  getTarget,
  getTargetEncodedName,
  searchTargets
};

const toDocument = (content) => {
  const sanitizedContent = sanitizeHTML(content);
  return parseDocument(sanitizedContent, {
    decodeEntities: true
  });
};
const toString = (node) => {
  return render(node);
};
const sanitizeHTML = (content) => {
  return content.replace(/\\/g, "");
};
const cutBodyContent = (content, wordCount) => {
  let parsedContent = "";
  let includedWords = 0;
  const openTags = [];
  const parser = new Parser({
    onopentag: (tag, tagAttributes) => {
      if (includedWords >= wordCount) {
        return;
      }
      const parsedAttributes = Object.keys(tagAttributes).reduce(
        (attributes, key) => `${attributes} ${key}="${tagAttributes[key]}"`,
        ""
      );
      parsedContent += `<${tag}${parsedAttributes}>`;
      openTags.push(tag);
    },
    ontext: (textContent) => {
      const words = textContent.split(/,|\s/g).filter(Boolean);
      if (words.length + includedWords <= wordCount) {
        includedWords += words.length;
        parsedContent += textContent;
        return;
      }
      words.map((word) => {
        if (includedWords + 1 <= wordCount) {
          includedWords += 1;
          parsedContent += word;
        }
      });
    },
    onclosetag: (tag) => {
      const toBeClosed = openTags.pop();
      if (!toBeClosed) {
        return;
      }
      if (toBeClosed === tag) {
        parsedContent = `${parsedContent}</${tag}>`;
        return;
      }
      openTags.push(toBeClosed);
    }
  });
  parser.write(content);
  return parsedContent;
};

var parse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toDocument: toDocument,
  toString: toString,
  sanitizeHTML: sanitizeHTML,
  cutBodyContent: cutBodyContent
});

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
const normalizeVersion = ({ body, article }) => {
  const _body = cloneDeep(body);
  const { version, bannerImage, primarySection, title, webtitle, authors } = article;
  if (version === 2)
    return _body;
  const articleContainer = new Element("div", {
    class: "articleContainer"
  });
  const articleWrapper = new Element("div", {
    class: "articleWrapper"
  });
  const articleContent = new Element("div", {
    class: "articleContent"
  });
  DomUtils.appendChild(articleContainer, articleWrapper);
  DomUtils.appendChild(articleWrapper, articleContent);
  if (bannerImage == null ? void 0 : bannerImage.url) {
    const figure = new Element("figure", {
      class: "bannerimage _fit-frame-height-to-content _align-right"
    });
    const image = new Element("div", {
      style: `background-image: url(${bannerImage.url}); display: block; height: 0px; overflow: hidden; padding-bottom: 40.6977%; background-position: 50% 50%;`
    });
    const caption = new Element(
      "figcaption",
      {
        style: "color: rgb(114, 175, 173); font-size: 10px; text-align: right;"
      },
      [new Text("BioCentury & Getty Images")]
    );
    DomUtils.appendChild(figure, image);
    DomUtils.appendChild(figure, caption);
    DomUtils.appendChild(articleContent, figure);
  }
  if (primarySection == null ? void 0 : primarySection.name) {
    const h2Element = new Element(
      "h2",
      {
        class: "kicker hide"
      },
      [new Text(primarySection.name)]
    );
    DomUtils.appendChild(articleContent, h2Element);
  }
  if (title) {
    const h1Element = new Element(
      "h1",
      {
        class: "text title"
      },
      [new Text(title)]
    );
    DomUtils.appendChild(articleContent, h1Element);
  }
  if (webtitle) {
    const h2Element = new Element(
      "h2",
      {
        class: "title-bottom webtitle"
      },
      [new Text(webtitle)]
    );
    DomUtils.appendChild(articleContent, h2Element);
  }
  const authorNames = authors && authors.map((author) => author.authorName);
  if (authorNames.length > 0) {
    const authors2 = new Element(
      "div",
      {
        class: "byline"
      },
      [new Text(authorNames.join(" ,"))]
    );
    DomUtils.appendChild(articleContent, authors2);
  }
  const date = new Element("div", {
    class: "date"
  });
  DomUtils.appendChild(articleContent, date);
  const paragraphs = DomUtils.findAll((elem) => elem.attribs.class === "bodytext", body);
  paragraphs.forEach((paragraph) => {
    paragraph.attribs.class = "text body";
  });
  [..._body].forEach((node) => {
    DomUtils.appendChild(articleContent, node);
  });
  return [articleContainer];
};
const extractBody = (document) => {
  const body = DomUtils.findOne((elem) => {
    return elem.name === "body";
  }, document.children);
  if (!(body == null ? void 0 : body.children)) {
    return document.children;
  }
  return body.children;
};
const extractScripts = (document) => {
  const scripts = [];
  const scriptsMap = /* @__PURE__ */ new Set();
  const element = DomUtils.findAll((elem) => {
    return elem.name === "script";
  }, document.children);
  element.forEach((elem) => {
    var _a;
    const validSrc = ((_a = elem.attribs) == null ? void 0 : _a.src) && /^http/.test(elem.attribs.src);
    const content = DomUtils.textContent(elem.children);
    if (validSrc) {
      scriptsMap.add(elem.attribs.src);
    }
    if (content.length > 0) {
      scriptsMap.add(content);
    }
  });
  scriptsMap.forEach((script, index) => {
    const uid = `js-script-${index}`;
    const isExternal = /^http/.test(script);
    scripts.push(__spreadValues$8({
      id: uid,
      content: isExternal ? "" : script
    }, isExternal && { src: script }));
  });
  return scripts;
};
const addDots = (elem) => {
  const text = cloneDeep(elem);
  const textContent = DomUtils.textContent(text.children);
  text.children = [...text.children, new Text(textContent.endsWith(".") ? ".." : "...")];
  return text;
};
const extractDescription = (content) => {
  const document = toDocument(content);
  const texts = [];
  let elements = DomUtils.findAll((elem) => {
    if (elem.name === "p" && elem.attribs.class && elem.attribs.class.includes("body")) {
      const text = DomUtils.textContent(elem.children);
      if (text.length > 0) {
        texts.push(text);
        return true;
      }
    }
    return false;
  }, document.children);
  if (!elements || elements.length === 0) {
    elements = DomUtils.findAll((elem) => {
      if (elem.name === "p") {
        const text = DomUtils.textContent(elem.children);
        if (text.length > 0) {
          texts.push(text);
          return true;
        }
      }
      return false;
    }, document.children);
  }
  if (!elements || elements.length === 0) {
    return "";
  }
  if (elements.length === 1) {
    return `<p>${texts[0].substring(0, 200)}...</p>`;
  }
  if (elements.length === 2) {
    return toString(addDots(elements[0]));
  }
  const previewSize = [texts[0], texts[1]].length / texts.length;
  if (previewSize > 50) {
    return toString(addDots(elements[0]));
  }
  return toString([elements[0], addDots(elements[1])]);
};
const replaceDataVizScripts = (article) => {
  const { bodyContent, dataVisualizations } = article;
  let DataVizBody = bodyContent;
  dataVisualizations.forEach((dataViz) => {
    var _a, _b, _c;
    if (((_a = dataViz.visualization) == null ? void 0 : _a.__typename) === "InfogramVisualization") {
      const infogramRegex = new RegExp(
        `<bcinfogram id="${(_b = dataViz.visualization) == null ? void 0 : _b.visId}"></bcinfogram>`,
        "g"
      );
      DataVizBody = DataVizBody.replace(infogramRegex, (_c = dataViz.visualization) == null ? void 0 : _c.embeddedScript);
    }
  });
  return DataVizBody;
};
const removeScripts = (body) => {
  const _body = cloneDeep(body);
  const flourish = DomUtils.findAll((elem) => {
    return elem.name === "script";
  }, _body);
  const isInfogramScript = (elem) => {
    var _a, _b;
    return (_b = (_a = elem.attribs) == null ? void 0 : _a.id) == null ? void 0 : _b.includes("infogram");
  };
  const isSurveyMonkeyScript = (elem) => {
    var _a, _b;
    return (_b = (_a = elem.attribs) == null ? void 0 : _a.src) == null ? void 0 : _b.includes("widget.surveymonkey");
  };
  flourish.forEach((elem) => {
    if (!isInfogramScript(elem) && !isSurveyMonkeyScript(elem)) {
      DomUtils.removeElement(elem);
    }
  });
  return _body;
};
const removeSocials = (body) => {
  const _body = cloneDeep(body);
  const socialMedia = DomUtils.findAll((elem) => {
    var _a;
    return ((_a = elem.attribs) == null ? void 0 : _a.class) === "social-media";
  }, _body);
  socialMedia.forEach((elem) => {
    DomUtils.removeElement(elem);
  });
  return _body;
};
const protectedArticle = (body) => {
  const _body = cloneDeep(body);
  const articleWrapper = DomUtils.findOne(
    (elem) => {
      var _a;
      return ((_a = elem.attribs) == null ? void 0 : _a.class) === "articleWrapper";
    },
    _body
  );
  const articleContent = DomUtils.findOne(
    (elem) => {
      var _a;
      return ((_a = elem.attribs) == null ? void 0 : _a.class) === "articleContent";
    },
    _body
  );
  if (!articleWrapper || !articleContent) {
    return _body;
  }
  const elementsToBeRemovedFromArticleContent = DomUtils.findAll(
    (elem) => elem.parent === articleContent && !["title", "byline", "date", "webtitle"].some(
      (className) => {
        var _a, _b;
        return (_b = (_a = elem.attribs) == null ? void 0 : _a.class) == null ? void 0 : _b.includes(className);
      }
    ),
    articleContent.children
  );
  elementsToBeRemovedFromArticleContent.forEach((elem) => {
    DomUtils.removeElement(elem);
  });
  const extraneousElementsInArticleWrapper = DomUtils.findAll(
    (elem) => {
      var _a;
      return ((_a = elem.attribs) == null ? void 0 : _a.class) !== "articleContent" && elem.parent === articleWrapper;
    },
    articleWrapper.children
  );
  extraneousElementsInArticleWrapper.forEach((elem) => {
    DomUtils.removeElement(elem);
  });
  return _body;
};
const addFlourishImage = ({ body, flourishScripts, url }) => {
  const flourishImages = flourishScripts.reduce((scripts, item) => {
    const { visId, thumbnail } = item;
    if (scripts[visId] || !thumbnail.url) {
      return scripts;
    }
    scripts[visId] = thumbnail.url;
    return scripts;
  }, {});
  const embedElem = DomUtils.findAll(
    (elem) => {
      var _a;
      return ((_a = elem.attribs) == null ? void 0 : _a.class) ? elem.attribs.class.includes("embed") : false;
    },
    body
  );
  embedElem.forEach((elem) => {
    const divHtmlDocIndex = elem.children.findIndex((node) => {
      const childElem = node;
      return childElem.attribs && "doc-html" in childElem.attribs;
    });
    let divHtmlDoc = new Element("div", {});
    if (divHtmlDocIndex !== -1) {
      divHtmlDoc = elem.children[divHtmlDocIndex];
      if (elem.children.length > 1) {
        for (let index = elem.children.length - 1; index >= 0; index -= 1) {
          if (index !== divHtmlDocIndex && elem.children[index])
            DomUtils.append(elem, elem.children[index]);
        }
      }
    }
    const [idNumber, defaultImage] = getRichMediaElements(divHtmlDoc);
    let image;
    if (flourishImages[idNumber]) {
      image = new Element("image", {
        class: "w-full block my-6",
        src: flourishImages[idNumber]
      });
    } else {
      image = new Element(
        "a",
        {
          class: "w-32 block my-6 mx-auto text-s text-center text-info bold",
          href: url
        },
        [
          new Element("image", {
            class: "w-32 block mx-auto",
            src: defaultImage
          }),
          new Text(
            `This article contains data graphics and/or multimedia. View this content online.`
          )
        ]
      );
    }
    DomUtils.append(elem, image);
    DomUtils.removeElement(elem);
  });
};
const addLinkTitle = ({ body, url }) => {
  const _body = cloneDeep(body);
  const element = DomUtils.findOne((elem) => {
    var _a, _b;
    return elem.name === "h1" && ((_b = (_a = elem.attribs) == null ? void 0 : _a.class) == null ? void 0 : _b.includes("title"));
  }, _body);
  if (!element) {
    return _body;
  }
  const title = element.children;
  const anchor = new Element(
    "a",
    {
      href: url
    },
    title
  );
  element.children = [anchor];
  return _body;
};
const injectVisualization = (article) => {
  const flourishRegex = /(<|&lt;)bcflourish(.*?)id="(.+?)"(.*?)(>|&gt;)/g;
  const tableRegex = /(<div class="embed".*\n.*"html">)(<iframe.*flourish.*<\/iframe>)(<\/div>\n<\/div>)/g;
  const { bodyContent, flourishScripts } = article;
  const flourishUrls = flourishScripts.reduce(
    (scripts, item) => {
      const { visId, flourishVisBody } = item;
      if (scripts[visId] || !(flourishVisBody == null ? void 0 : flourishVisBody.url)) {
        return scripts;
      }
      scripts[visId] = flourishVisBody.url;
      return scripts;
    },
    {}
  );
  const replacedBody = bodyContent.replace(flourishRegex, (...groups) => {
    const [match, _, __, id] = groups;
    const scriptUrl = flourishUrls[id.trim()];
    if (!scriptUrl) {
      return match;
    }
    return scriptUrl;
  });
  const resultBody = replacedBody.replace(tableRegex, (...groups) => {
    const [_, __, iframe, ___] = groups;
    return iframe;
  });
  return resultBody;
};
const insertCompanyLinks = (article) => {
  const { bodyContent, companies } = article;
  const profilesUrl = process.env.NEXT_PUBLIC_BCIQ_PROFILES_URL;
  if (!profilesUrl) {
    return bodyContent;
  }
  let newBody = bodyContent;
  companies.forEach((company) => {
    var _a;
    const name = (_a = company == null ? void 0 : company.name) != null ? _a : "";
    const companyAlternativeNames = [
      name.replace(" ", "&nbsp;"),
      name.replace(" ", "&#160;"),
      name.replace(" ", "&#xA0;"),
      name
    ];
    for (const companyName of companyAlternativeNames) {
      if (newBody.indexOf(companyName) > -1) {
        newBody = newBody.replace(
          companyName,
          ` <a href="${profilesUrl}/companies/${company == null ? void 0 : company.encodedName}">${companyName}</a>`
        );
        break;
      }
    }
  });
  return newBody;
};
const getImages = (body) => {
  const _body = cloneDeep(body);
  const images = DomUtils.findAll((elem) => {
    return elem.attribs["doc-image"] === "image" || elem.name === "image";
  }, _body);
  const imagesSrc = images.map((image) => {
    var _a, _b;
    const src = ((_b = (_a = image.attribs) == null ? void 0 : _a.style.match(/url\((.*?)\)/)) == null ? void 0 : _b[1]) || image.attribs.src || null;
    return src;
  });
  return compact$1(imagesSrc);
};
const getRichMediaElements = (div) => {
  const stringDiv = toString([div]);
  if (stringDiv.includes("buzzsprout")) {
    const divFlourish = div.children.find((node) => {
      const childElem = node;
      return childElem.attribs && "id" in childElem.attribs;
    });
    const { id } = (divFlourish == null ? void 0 : divFlourish.attribs) || { id: "" };
    const idNumber = id.replace(/\D/g, "");
    return [idNumber, "https://media-graphcms-com.biomarinproxy01.infotrieve.com/6gCAHTDiSduABiEFA89o"];
  }
  if (stringDiv.includes("bcflourish") && stringDiv.includes("iframe")) {
    const divFlourish = div.children.find((node) => {
      const childElem = node;
      return childElem.attribs && "src" in childElem.attribs;
    });
    const divFourishString = divFlourish ? toString([divFlourish]) : "";
    const idNumber = divFourishString.match(/(\d+)/);
    return [idNumber ? idNumber[1] : "", "https://media-graphcms-com.biomarinproxy01.infotrieve.com/Anrt5wAiQmCpqChsJa3O"];
  }
  if (stringDiv.includes("view.vzaar.com")) {
    const idAttr = stringDiv.match(/(vzvd-\d+)/);
    const idNumber = idAttr ? idAttr[1].replace(/\D/g, "") : "";
    return [idNumber, "https://media-graphcms-com.biomarinproxy01.infotrieve.com/PndzsqRhSDeAzWLziH1v"];
  }
  if (stringDiv.includes("docs.google.com")) {
    const divFlourish = div.children.find((node) => {
      const childElem = node;
      return childElem.attribs && "src" in childElem.attribs;
    });
    const { src } = (divFlourish == null ? void 0 : divFlourish.attribs) || { src: "" };
    const idNumber = src.match(/^https:\/\/docs\.google\.com\/presentation\/d\/e\/(.*)\/.*/);
    return [idNumber ? idNumber[1] : "", "https://media-graphcms-com.biomarinproxy01.infotrieve.com/OHbomWVfT2az6TfJDtpd"];
  }
  if (stringDiv.includes("flourish-embed")) {
    const divFlourish = div.children.find((node) => {
      const childElem = node;
      return childElem.attribs && ("data-src" in childElem.attribs || "src" in childElem.attribs);
    });
    const dataSrc = (divFlourish == null ? void 0 : divFlourish.attribs["data-src"]) || (divFlourish == null ? void 0 : divFlourish.attribs.src) || "";
    const idNumber = /(\d+)\W/.exec(dataSrc);
    return [idNumber ? idNumber[1] : "", "https://media-graphcms-com.biomarinproxy01.infotrieve.com/Anrt5wAiQmCpqChsJa3O"];
  }
  return ["", "https://media-graphcms-com.biomarinproxy01.infotrieve.com/Nr5XX4iQiq3BtHlQ8ZOC"];
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  normalizeVersion: normalizeVersion,
  extractBody: extractBody,
  extractScripts: extractScripts,
  extractDescription: extractDescription,
  replaceDataVizScripts: replaceDataVizScripts,
  removeScripts: removeScripts,
  removeSocials: removeSocials,
  protectedArticle: protectedArticle,
  addFlourishImage: addFlourishImage,
  addLinkTitle: addLinkTitle,
  injectVisualization: injectVisualization,
  insertCompanyLinks: insertCompanyLinks,
  getImages: getImages
});

const isProtected = (body) => /article-count/.test(body);
const Article = {
  isProtected,
  parse: parse$1,
  utils
};

const Authentication = { Credentials };

function isArticle(obj) {
  return obj.__typename === GraphCMSModel.Article;
}
const requiredPermissions = (resource) => {
  var _a;
  const permissions = [];
  if (isArticle(resource) && resource.permissionsRequired) {
    (_a = resource.permissionsRequired) == null ? void 0 : _a.forEach(({ requirement }) => {
      if (!requirement) {
        return;
      }
      requirement.forEach((item) => permissions.push(item));
    });
  }
  if (!isArticle(resource) && resource.eventRequired) {
    permissions.push(resource.eventRequired);
  }
  return permissions;
};
const isAllowed = (resource, accessToken) => {
  if (isArticle(resource)) {
    return articleAllowed(resource, accessToken);
  }
  return pageAllowed(resource, accessToken);
};
const articleAllowed = (article, accessToken) => {
  var _a, _b;
  const permissions = requiredPermissions(article);
  const freeWithSignup = (_a = article.permissionsRequired) == null ? void 0 : _a.some(
    ({ freeWithRegistration }) => freeWithRegistration
  );
  if (article.freeContent && !freeWithSignup) {
    return true;
  }
  if (!accessToken) {
    return false;
  }
  const customClaims = (_b = JWTDecode(accessToken)) == null ? void 0 : _b.customClaims;
  const {
    roles,
    purchased_articles: purchasedArticles,
    purchased_conferences: individualConferences,
    isBCIQ,
    isPubs,
    isPubsArchives
  } = customClaims || {};
  if (purchasedArticles == null ? void 0 : purchasedArticles.includes(article.legacyId)) {
    return true;
  }
  if ((roles == null ? void 0 : roles.includes(RoleType.Admin)) || isPubsArchives || isBCIQ || isPubs) {
    return true;
  }
  if (isPubsArchives) {
    const limitDate = DateTime.utc().minus({ weeks: 12 });
    const articleDate = DateTime.fromISO(article.authoringDateTime).toUTC();
    if (articleDate > limitDate) {
      return true;
    }
  }
  if (freeWithSignup) {
    return true;
  }
  return permissions.some(({ __typename, id }) => {
    const isConference = __typename === GraphCMSModel.Conference;
    return !!(isConference && (individualConferences == null ? void 0 : individualConferences.includes(id)));
  });
};
const pageAllowed = (page, accessToken) => {
  var _a;
  if (!page.protected && !page.permission) {
    return true;
  }
  if (!accessToken) {
    return false;
  }
  const customClaims = (_a = JWTDecode(accessToken)) == null ? void 0 : _a.customClaims;
  const {
    roles,
    purchased_conferences: individualConferences,
    isPubsArchives,
    isBCIQ,
    isPubs
  } = customClaims || {};
  if (page.permission && page.permission.length > 0) {
    return page.permission.some((role) => roles == null ? void 0 : roles.includes(role));
  }
  if (!page.eventRequired) {
    return true;
  }
  if ((roles == null ? void 0 : roles.includes(RoleType.Admin)) || isPubsArchives || isBCIQ || isPubs) {
    return true;
  }
  if (page.eventRequired) {
    const permissions = requiredPermissions(page);
    return permissions.some(({ __typename, id }) => {
      const isConference = __typename === GraphCMSModel.Conference;
      return isConference && (individualConferences == null ? void 0 : individualConferences.includes(id));
    });
  }
  return false;
};
const Roles = { isAllowed };

const Authorization = { Roles };

const useCache = (response) => {
  response.setHeader("Cache-Control", "s-maxage=3600, max-age=3600");
};
const disableCache = (response) => {
  response.setHeader("Cache-Control", "private, no-store, max-age=0");
};
const setNoCache = (response) => {
  response.setHeader("Cache-Control", "no-cache, max-age=3600, must-revalidate");
};
const usePrivateCache = (response) => {
  response.setHeader("Cache-Control", "private, no-cache");
};
const Cache = {
  useCache,
  disableCache,
  setNoCache,
  usePrivateCache
};

const isBcDomain = (host) => {
  return `.${host.split(".").reverse().splice(0, 2).reverse().join(".")}` === process.env.BIOCENTURY_DOMAIN;
};
const domainsMap = /* @__PURE__ */ new Map([
  ["BioCentury", process.env.NEXT_PUBLIC_BIOCENTURY_URL || "https://biocentury-com.biomarinproxy01.infotrieve.com"],
  ["BCIQ", process.env.NEXT_PUBLIC_BCIQ_URL || "https://bciq-biocentury-com.biomarinproxy01.infotrieve.com"],
  ["Conferences", process.env.NEXT_PUBLIC_CONFERENCES_URL || "https://conferences-biocentury-com.biomarinproxy01.infotrieve.com"],
  [
    "Identify",
    process.env.NEXT_PUBLIC_BIOCENTURY_IDENTITY_URL || "https://login-biocentury-com.biomarinproxy01.infotrieve.com"
  ],
  [
    "Profiles",
    process.env.NEXT_PUBLIC_BCIQ_PROFILES_URL || "https://profiles-biocentury-com.biomarinproxy01.infotrieve.com/companies"
  ]
]);
const Domain = {
  isBcDomain,
  domainsMap
};

const environment = process.env.SENTRY_ENV || process.env.NODE_ENV || "production";
const init = () => {
  init$2({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment,
    enabled: process.env.NODE_ENV !== "development",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1
  });
};
const Sentry = {
  init,
  captureException
};

var __defProp$7 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __async$f = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetch$1 = fetchRetry(fetch$2, {
  retries: 2,
  retryDelay: 100
});
const fetcher$2 = (_0) => __async$f(void 0, [_0], function* ({ query, variables, preview }) {
  const gcmsEndpoint = process.env.GRAPHCMS_PROJECT_ENDPOINT || process.env.NEXT_PUBLIC_GRAPHCMS_PROJECT_ENDPOINT;
  if (!gcmsEndpoint) {
    throw new Error("GRAPHCMS_PROJECT_ENDPOINT not defined in env");
  }
  const gcmsAuthToken = process.env.GRAPHCMS_PUBLISHED_AUTH_TOKEN || process.env.NEXT_PUBLIC_GRAPHCMS_PUBLISHED_AUTH_TOKEN;
  const isDraftEnabled = process.env.ENABLE_DRAFTS === "true";
  const stage = isDraftEnabled || preview ? "DRAFT" : "PUBLISHED";
  const buildHeader = () => {
    return __spreadProps$4(__spreadValues$7({
      "Content-Type": "application/json"
    }, gcmsAuthToken && { Authorization: `Bearer ${gcmsAuthToken}` }), {
      "gcms-stage": stage
    });
  };
  const response = yield fetch$1(gcmsEndpoint, {
    method: "POST",
    headers: buildHeader(),
    body: JSON.stringify({
      query,
      variables
    })
  });
  const json = yield response.json();
  response.headers.forEach((value, key) => {
  });
  if (json.errors) {
    Sentry.captureException(new Error(JSON.stringify(json.errors)));
  }
  return json.data;
});

const ArticlePackage = `
  ArticlePackage {
    __typename
    id
  }
`;

const companyFields = `
  __typename
  id
  code
  name
  encodedName
`;

const Conference = `
  Conference {
    __typename
    id
  }
`;

const dataVisFields = `
__typename
id
name
visualization {
  __typename
  ... on InfogramVisualization {
    visId
    visImage {
      url
    }
    embeddedScript
  }
}`;

const diseaseCategoryFields = `
name
`;

const flourishFields = `
  __typename  
  id
  visId

  thumbnail {
    url
    width
    height
  }

  flourishVisBody {
    url
  }
`;

const productFields = `
name
`;

const sponsorBannerFields = `
  __typename
  id
  title
  sponsor {
    sponsorType
    company {
      code
      encodedName
      name
    }
    logo {
      url
    }
    externalUrl
  }
  logoUrl
  showVendorLogoOnBanner
  useCompactMobileLayout
  bannerHeadline
  sponsorName
  bannerText
`;

const targetFields = `
name
code
`;

const articlePublicFields = `
  __typename
  id
  legacyId
  title
  webtitle
  url
  bannerImage {
    url
  }
  homepageImage {
    url
  }
  thumbnail {
    url
  }
  primarySection {
    name
  }
  sponsorBanner {
    ${sponsorBannerFields}
  }
  adControl {
    disableGoogleAdsOnComponent
  }
  version
  tocAbstract
  latestArticlePreview
  authoringDateTime
  majorUpdateDateTime
  majorUpdateMessage
  articleType {
    name
  }
  wordCount
  includeWeeklyEdition
`;
const articleFields = `
  ${articlePublicFields}

  additionalTag
  freeContent
  mobilePinning
  commentary
  dealsFilter
  bodyContent
  scripts
  featuredStory
  bcxTopStory
  
  authors {
    authorName
  }
  
  adControl {
    disableGoogleAdsOnComponent
    sponsorBanner {
      ${sponsorBannerFields}
    }
  }
  

  companies {
    ${companyFields}
  }

  diseaseCategories {
    ${diseaseCategoryFields}
  }

  flourishScripts {
    ${flourishFields}
  }

  dataVisualizations {
    ${dataVisFields}
  }

  products {
    ${productFields}
  }

  targets {
    ${targetFields}
  }

  permissionsRequired {
    freeWithRegistration

    requirement {
      ... on ${ArticlePackage}
      ... on ${Conference}
    }
  }

  articleCategories {
    name
    sponsorBanner {
      ${sponsorBannerFields}
    }
  }

  fieldTags {
    name
  }

  additionalTag

  articleType {
    name
  }

  articlePackagePart {
    __typename
    articlePackage {
      articlePackageParts {
        sequence
        componentTitle {
          raw
        }
        componentSubTitle {
          raw
        }
        article {
          ${articlePublicFields}
        }
      }
    }
  }

  articlePackageRelatedArticle {
    __typename
    articlePackage {
      articlePackageRelatedArticles {
        componentTitle {
          raw
        }
        componentSubTitle {
          raw
        }
        article {
          ${articlePublicFields}
        }
      }
    }
  }
`;
const articleFieldsSimplified = `
  __typename
  id
  legacyId
  title
  webtitle
  url
  version
  tocAbstract
  latestArticlePreview
  authoringDateTime
  majorUpdateDateTime
  majorUpdateMessage
  wordCount
  includeWeeklyEdition
  additionalTag
  freeContent
  mobilePinning
  commentary
  dealsFilter
  bodyContent
  scripts
  featuredStory
  bcxTopStory
  additionalTag

  articleType {
    id
    name
  }

  authors {
    authorName
  }

  bannerImage {
    url
  }

  homepageImage {
    url
  }

  thumbnail {
    url
  }

  primarySection {
    name
  }

  fieldTags {
    name
  }

  companies {
    __typename
     id
     code
     name
     encodedName
  }

  diseaseCategories {
    ${diseaseCategoryFields}
  }

  flourishScripts {
    __typename
     id
  }

  dataVisualizations {
    __typename
     id
  }

  products {
   ${productFields}
  }

  targets {
    ${targetFields}
  }

  articlePackagePart {
    __typename
    articlePackage {
      articlePackageParts {
        sequence
        componentTitle {
          raw
        }
        componentSubTitle {
          raw
        }
        article {
          ${articlePublicFields}
        }
      }
    }
  }

  articlePackageRelatedArticle {
    __typename
    articlePackage {
      articlePackageRelatedArticles {
        componentTitle {
          raw
        }
        componentSubTitle {
          raw
        }
        article {
          ${articlePublicFields}
        }
      }
    }
  }

  permissionsRequired {
    freeWithRegistration

    requirement {
      ... on ${ArticlePackage}
      ... on ${Conference}
    }
  }

  articleCategories {
    id
    name
  }
`;

const feedMap = {
  articlesConnection: {
    orderType: "ArticleOrderByInput",
    whereType: "ArticleWhereInput"
  }
};
const fetchFeed = ({
  model,
  limit,
  orderBy,
  orderOption,
  where
}) => {
  const customOrder = orderBy && orderBy.length > 0 ? `${orderBy}_${orderOption || "ASC"}` : void 0;
  return fetcher$2({
    query: `
    query Feed(
      $first: Int,
      $orderBy: ${feedMap[model].orderType},
      $where: ${feedMap[model].whereType}
    ) {
      feed: ${model}(first: $first, orderBy: $orderBy, where: $where) {
        edges {
          node {
            __typename
            ... on Article {
              ${articlePublicFields}
            }
          }
        }
      }
    }`,
    variables: {
      first: limit,
      orderBy: customOrder,
      where
    }
  });
};

var __defProp$6 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __async$e = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const parse = (blocks) => __async$e(void 0, null, function* () {
  const parsedBlocks = [];
  const requests = [];
  let count = 0;
  for (const block of blocks) {
    const parsedBlock = __spreadValues$6({}, block);
    if (parsedBlock.feedQuery) {
      requests.push(
        getFeed(parsedBlock.feedQuery, parsedBlock.__typename === "ContentCardComponent")
      );
    }
    parsedBlocks.push(parsedBlock);
  }
  if (requests.length > 0) {
    const feeds = yield Promise.all(requests);
    for (const block of parsedBlocks) {
      if (block.feedQuery) {
        block.feedResponse = feeds[count];
        count += 1;
      }
    }
  }
  return parsedBlocks;
});
const getFeed = (feed, fetchOnlyFirstItem) => __async$e(void 0, null, function* () {
  if (feed.model === QueryModel.articlesConnection) {
    const response = yield fetchFeed(feed);
    return response;
  }
  if (feed.model === QueryModel.algolia && fetchOnlyFirstItem) {
    const options = parseFromString(feed.where.query);
    const result = yield query({
      appId: process.env.ALGOLIA_APP_ID || process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
      apiKey: process.env.ALGOLIA_API_KEY || process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,
      indexName: process.env.NEXT_PUBLIC_ALGOLIA_ARTICLE_INDEX_NAME || "",
      options: __spreadProps$3(__spreadValues$6({}, options), {
        params: __spreadValues$6(__spreadValues$6(__spreadValues$6({}, options.params), feed.limit && { hitsPerPage: feed.limit }), fetchOnlyFirstItem && { hitsPerPage: 1 })
      })
    });
    return result;
  }
  return null;
});

const Feed = {
  parse
};

const fetchAllPagePaths = ({ product, pageSize = 500 }) => {
  return fetcher$2({
    query: `
      query PagesQuery($product: Products! $pageSize: Int) {
        pages(first: $pageSize where: { product: $product }) {
          path
        }
      }
      `,
    variables: { product, pageSize }
  });
};

const fetchArticles = ({
  after,
  pageSize,
  id,
  sortOrder = OrderOption.DESC
}) => {
  const orderBy = `updatedAt_${sortOrder}`;
  if (after) {
    return fetcher$2({
      query: `
      query ArticlesConnectionQuery($after: String! $pageSize: Int $orderBy: ArticleOrderByInput) {
        articlesConnection(after: $after, first: $pageSize,  orderBy: $orderBy) {
          aggregate {
            count
          }
          pageInfo {
            pageSize
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              ${articleFields}
            }
          }
          }
      }`,
      variables: {
        after,
        pageSize,
        orderBy,
        sortOrder
      }
    });
  }
  if (id) {
    return fetcher$2({
      query: `
      query ArticlesConnectionQuery($id: ID!) {
        articlesConnection(where: {id: $id } ) {
          aggregate {
            count
          }
          pageInfo {
            pageSize
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              ${articleFields}
            }
          }
          }
      }`,
      variables: {
        after,
        pageSize,
        orderBy,
        id,
        sortOrder
      }
    });
  }
  return fetcher$2({
    query: `
    query ArticlesConnectionQuery( $pageSize: Int $orderBy: ArticleOrderByInput) {
      articlesConnection(first: $pageSize,  orderBy: $orderBy) {
        aggregate {
          count
        }
        pageInfo {
          pageSize
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          node {
            ${articleFields}
          }
        }
        }
    }
`,
    variables: {
      pageSize,
      after,
      orderBy,
      sortOrder
    }
  });
};
const fetchArticlesByIds = (ids) => {
  return fetcher$2({
    query: `
    query ArticlesQuery($ids: [Int!]) {
      articles(where: { legacyId_in: $ids }, orderBy: publishedAt_DESC) {
        ${articleFields}
      }
    }`,
    variables: {
      ids
    }
  });
};
const fetchArticlesCardByIds = (ids) => {
  return fetcher$2({
    query: `
    query ArticlesQuery($ids: [ID!], $first: Int) {
      articles(where: { id_in: $ids }, first: $first) {
        ${articlePublicFields}
      }
    }`,
    variables: {
      ids,
      first: ids.length
    }
  });
};

const fetchPagePaths = (path) => {
  return fetcher$2({
    query: `
      query PagesQuery() {
        page(where: { path: "${path}" }) {
          parentPage { path }
        }
      }
      `
  });
};

const dataviz = `
  __typename
  id
  name
  hosts {
    __typename
    ... on Article {
      ${articlePublicFields}
    }
    ... on Page {
      pageType
      path
    }
  }

`;

const feedQuery = `
  FeedQuery {
    id
    name
    model
    limit
    perPage
    orderBy
    orderOption
    where
    buttonText
    buttonType
    buttonStyle
  }
`;

const podcast = `
  __typename
  id
  title
  podcastId
  url
  script
  image {
    url
  }
  hosts {
    __typename
    ... on Article {
      ${articlePublicFields}
    }
    ... on Page {
      pageType
      path
    }
  }

`;

const webinar = `
  __typename
  id
  webinarTitle: title
  endDate
  startDate
  hosts {
    __typename
    ... on Article {
      ${articlePublicFields}
    }
    ... on Page {
      pageType
      path
    }
  }

`;

const whitepaper = `
  __typename
  id
  title
  contentHostedByBioCentury
  noConsentIsRequired
  consentHosting
  consentText
  thirdPartyContentReference
  description
  summary
  author
  authorWebsite
  legacyUrl
  primarySection
  whitepaperImage {
    url
  }
  whitepaperPdf {
    url
  }
  tags
  abstractSummary
  whitepaperDate
  category
`;

const TitleComponent = `
  id
  content
  subtitle {
    raw
  }
  alignment
  headingSize: size
  margin
  icon {
    url
    width
    height
  }
`;
const MarkdownComponent = `
  id
  content
  internalTitle
`;
const ButtonComponent = `
  id
  content
  viewType
  title
  style
  buttonSize: size
  isExternal
`;
const LoginButtonComponent = `
  id
  title
  style
  buttonSize: size
`;
const CheckoutButtonComponent = `
  id
  title
  style
  buttonSize: size
`;
const RegisterButtonComponent = `
  id
  title
  style
  buttonSize: size
`;
const PodcastButtonComponent = `
  id
  title
  style
  buttonSize: size
  podcastName
  planId
`;
const InformativeCardComponent = `
  id
  viewType
  title
  subtitle
  content {
    raw
  }
  contentAlignment: alignment

  image {
    url
    width
    height
  }
  imageAlignment

  buttonUrl
  buttonText
  buttonStyle
  buttonType
  buttonAlignment
`;
const MarketingCardComponent = `
  id
  viewType
  contentList: content
  title
  image {
    url
    width
    height
  }
  darkMode
`;
const ContentCardComponent = `
  id
  viewType
  size
  imagePadding
  seeMoreUrl
  cards: content {
    __typename
    ... on Article {
      ${articlePublicFields}
    }
    ... on Podcast {
      ${podcast}
    }
    ... on Webinar {
      ${webinar}
    }
    ... on DataVisualization {
      ${dataviz}
    }
    ... on Whitepaper {
      ${whitepaper}
    }
    ... on Page {
      id
      pageType
      product
      headline
      webtitle
      contentCardDate
      path
      section {
        name
      }
      thumbnail {
        url
        width
        height
      }
      parentPage {
        id
      }
    }
  }
  feedQuery: firstItemFeedQuery {
    __typename
    ... on ${feedQuery}
  }
`;
const CarouselComponent = `
  id
  visibleColumns
  withIndicator
  withFade
  border
  spacing
  carouselViewType: viewType
  size
  carourelTitle: title
  imagePadding
  arrows
  blocks {
    __typename
    ... on Node {
      id
    }
  }
  feedQuery {
    __typename
    ... on ${feedQuery}
  }
`;
const GridComponent = `
  id
  desktopColumns
  mobileColumns
  contentAlignment: alignment
  border
  spacing
  gridViewType: viewType
  size
  imagePadding
  blocks {
    __typename
    ... on Node {
      id
    }
  }
  feedQuery {
    __typename
    ... on ${feedQuery}
  }
`;
const TabItemComponent = `
    id
    title
    blocks {
      __typename
      ... on Node {
        id
      }
    }
`;
const TabComponent = `
    __typename
    id
    alignment
    blocks {
      __typename
      ... on Node {
        id
      }
    }
`;
const MasoneryFields = `
  __typename
  id
  name
  border
  spacing
  articles {
    ... on Article {
      ${articlePublicFields}
    }
  }
`;
const CompaniesComponent = `
  __typename
  id
  companyGroups {
    id
    title
    __typename
    companies {
      id
      name
      __typename
    }
  }
`;
const PeopleComponent = `
  __typename
  id
  people {
    __typename
    id
    name
    firstName
    lastName
    jobTitle
    company
    photo {
      url
      width
      height
    }
    links {
      __typename
      url
      type
    }
    newBio {
      raw
    }
  }
`;
const scheduleComponent = `
id
events {
  id
  title
}
`;
const ConferenceSection = `
  id
  title
  components {
    __typename
    ... on CompaniesComponent {
      ${CompaniesComponent}
    }
    ... on PeopleComponent {
      ${PeopleComponent}
    }
    ... on ScheduleComponent {
      ${scheduleComponent}
    }
  }
`;
const MyFeedComponent = `
  __typename
  id
  feedTitle: title
  configLabel
  defaultFeedQuery {
    id
    name
    model
    limit
    perPage
    where
  }
`;
const CollapsibleComponent = `
  __typename
  id
  collapsedByDefault
  titleComponent {
    ${TitleComponent}
  }
  blocks {
    __typename
    ... on Node {
      id
    }
  }
`;

const childrenPages = `
    childrenPages {
      title
      path
      pageType
      product
      protected
      permission
      headline

      childrenPages {
        title
        path
        pageType
        product
        protected
        permission
        headline
      }
    }
`;
const pageBasicFields = `
    __typename
    id
    stage
    title
    path
    product
    showHomePageNav
    permission
    protected
    permission

    loggedInPage {
      __typename
      id
      path
    }
    loggedInPageIP {
      __typename
      id
      path
    }
    loggedOutPage {
      __typename
      id
      path
    }
    permissionDeniedPage {
      __typename
      id
      path
    }

    ${childrenPages}

		parentPage {
			path

      ${childrenPages}

      parentPage {
        path

        ${childrenPages}
      }
		}
`;
const pageFullFields = `
    __typename
    id
    stage
    admin
    title
    path
    pageType
    layout
    product
    permission
    protected
    permission
    showHomePageNav
    portalHeading
    redirectUrl
    redirectUrlMobile
    pageHeaderTitle
    pageHeaderDescription

    loggedInPage {
      __typename
      id
      path
    }
    loggedInPageIP {
      __typename
      id
      path
    }
    loggedOutPage {
      __typename
      id
      path
    }
    permissionDeniedPage {
      __typename
      id
      path
    }

    ${childrenPages}

		parentPage {
			path

      ${childrenPages}

      parentPage {
        path

        ${childrenPages}
      }
		}

    opengraph {
      image {
        url
      }
      description
      siteName
      title
      url
      type
    }

    twitterTag {
      description
      image {
        url
      }
      title
      url
      imageAlt
      card
    }
    adControl {
      disableGoogleAdsOnComponent
      sponsorBanner {
        ${sponsorBannerFields}
      }
    }
    eventRequired {
      ... on ${Conference}
    }

    blocks {
      __typename
      ... on Node {
        id
      }
    }
`;
const pageFields$1 = `
    __typename
    id
    admin
    title
    path
    pageType
    layout
    product
    protected
    portalHeading

    ${childrenPages}

		parentPage {
			path

      ${childrenPages}

      parentPage {
        path

        ${childrenPages}
      }
		}

    opengraph {
      image {
        url
      }
      description
      siteName
      title
      url
      type
    }

    twitterTag {
      description
      image {
        url
      }
      title
      url
      imageAlt
      card
    }

    webtitle
    headline
    contentCardDate
    section {
      name
    }
    fieldTags {
      name
    }
    thumbnail {
      url
    }
    additionalTag

    eventRequired {
      ... on ${Conference}
    }

    blocks {
      __typename
      ... on ButtonComponent {
        ${ButtonComponent}
      }
      ... on LoginButtonComponent {
        ${LoginButtonComponent}
      }
      ... on RegisterButtonComponent {
        ${RegisterButtonComponent}
      }

      ... on PodcastButtonComponent {
        ${PodcastButtonComponent}
      }
      ... on InformativeCardComponent {
        ${InformativeCardComponent}
      }
      ... on MarketingCardComponent {
        ${MarketingCardComponent}
      }
      ... on TitleComponent {
        ${TitleComponent}
      }
      ... on MarkdownComponent {
        ${MarkdownComponent}
      }
      ... on ContentCardComponent {
        ${ContentCardComponent}
      }
      ... on MasoneryComponent {
        ${MasoneryFields}
      }
      ... on CarouselComponent {
        ${CarouselComponent}
      }
      ... on GridComponent {
        ${GridComponent}
      }
      ... on TabComponent {
        ${TabComponent}
      }
      ... on CompaniesComponent {
        ${CompaniesComponent}
      }
      ... on ConferenceSection {
        ${ConferenceSection}
      }
      ... on PeopleComponent {
        ${PeopleComponent}
      }
      ... on MyFeedComponent {
        ${MyFeedComponent}
      }
      ... on CollapsibleComponent {
        ${CollapsibleComponent}
      }
    }
`;
const pageAlgoliaFields = `
    __typename
    id
    admin
    title
    path
    pageType
    layout
    product
    protected
    portalHeading

    ${childrenPages}

		parentPage {
			path

      ${childrenPages}

      parentPage {
        path

        ${childrenPages}
      }
		}
    webtitle
    headline
    contentCardDate
    section {
      name
    }
    fieldTags {
      name
    }
    thumbnail {
      url
    }
    additionalTag

    eventRequired {
      ... on ${Conference}
    }

    blocks {
      __typename
      ... on InformativeCardComponent {
        ${InformativeCardComponent}
      }
      ... on MarketingCardComponent {
        ${MarketingCardComponent}
      }
      ... on TitleComponent {
        ${TitleComponent}
      }
      ... on MarkdownComponent {
        ${MarkdownComponent}
      }
      ... on ContentCardComponent {
        ${ContentCardComponent}
      }
      ... on MasoneryComponent {
        ${MasoneryFields}
      }
      ... on CarouselComponent {
        ${CarouselComponent}
      }
      ... on GridComponent {
        ${GridComponent}
      }
      ... on TabComponent {
        ${TabComponent}
      }
      ... on CompaniesComponent {
        ${CompaniesComponent}
      }
      ... on ConferenceSection {
        ${ConferenceSection}
      }
      ... on PeopleComponent {
        ${PeopleComponent}
      }
      ... on MyFeedComponent {
        ${MyFeedComponent}
      }
      ... on CollapsibleComponent {
        ${CollapsibleComponent}
      }
    }
`;

const fetchPageContentById = ({
  id,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($id: ID!) {
        page(where: { id: $id }) {
          stage
          ${pageFields$1}
        }

        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      id,
      pageSize
    }
  });
};

var __async$d = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const getArticlesComponents = (articles) => __async$d(void 0, null, function* () {
  var _a, _b, _c;
  const componentsIdsMap = /* @__PURE__ */ new Map();
  const componentsMap = /* @__PURE__ */ new Map();
  articles.forEach((article) => {
    if (article == null ? void 0 : article.companies) {
      const companies = new Set(componentsIdsMap.get("companies"));
      article.companies.forEach((item) => companies.add(item.id));
      componentsIdsMap.set("companies", companies);
    }
    if (article == null ? void 0 : article.flourishScripts) {
      const flourishes = new Set(componentsIdsMap.get("flourishScripts") || []);
      article.flourishScripts.forEach((item) => flourishes.add(item.id));
      componentsIdsMap.set("flourishScripts", flourishes);
    }
    if (article == null ? void 0 : article.dataVisualizations) {
      const datavis = new Set(componentsIdsMap.get("dataVisualizations") || []);
      article.dataVisualizations.forEach((item) => datavis.add(item.id));
      componentsIdsMap.set("dataVisualizations", datavis);
    }
  });
  const components = yield fetcher$2({
    query: `
      query Components($company_ids: [ID!], $flourish_ids: [ID!], $datavis_ids: [ID!]) {
        companies(last: 300, where: { id_in: $company_ids}) {
          ${companyFields}
        }
        flourishScripts(last: 300, where: { id_in: $flourish_ids}) {
          ${flourishFields}
        }
        dataVisualizations(last: 300, where: { id_in: $datavis_ids}) {
          ${dataVisFields}
        }
      }`,
    variables: {
      company_ids: [...componentsIdsMap.get("companies")],
      flourish_ids: [...componentsIdsMap.get("flourishScripts")],
      datavis_ids: [...componentsIdsMap.get("dataVisualizations")]
    }
  });
  (_a = components == null ? void 0 : components.companies) == null ? void 0 : _a.forEach((item) => {
    componentsMap.set(item.id, item);
  });
  (_b = components == null ? void 0 : components.flourishScripts) == null ? void 0 : _b.forEach((item) => {
    componentsMap.set(item.id, item);
  });
  (_c = components == null ? void 0 : components.dataVisualizations) == null ? void 0 : _c.forEach((item) => {
    componentsMap.set(item.id, item);
  });
  return componentsMap;
});
const mergeComponentsArticles = (articles, components) => {
  const _articles = /* @__PURE__ */ new Map();
  articles.forEach((article, key) => {
    const _article = cloneDeep(article);
    if (article == null ? void 0 : article.companies) {
      _article.companies = compact$1(
        article.companies.map((item) => components.get(item.id))
      );
    }
    if (article == null ? void 0 : article.flourishScripts) {
      _article.flourishScripts = article.flourishScripts.map(
        (item) => components.get(item.id)
      );
    }
    if (article == null ? void 0 : article.dataVisualizations) {
      _article.dataVisualizations = article.dataVisualizations.map(
        (item) => components.get(item.id)
      );
    }
    if (article == null ? void 0 : article.articleCategories) {
      _article.articleCategories = article.articleCategories.map((item) => {
        const _item = cloneDeep(item);
        return _item;
      });
    }
    _articles.set(key, _article);
  });
  return _articles;
};

var __async$c = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchArticle = (_0) => __async$c(void 0, [_0], function* ({ articleId }) {
  const response = yield fetcher$2({
    query: `
      query Article($articleId: Int!) {
          article(where: { legacyId: $articleId}) {
            ${articleFieldsSimplified}
          }
      }`,
    variables: { articleId }
  });
  const article = (/* @__PURE__ */ new Map()).set(response.article.id, response.article);
  const components = yield getArticlesComponents([...article.values()]);
  const articlesFull = mergeComponentsArticles(article, components);
  return {
    article: articlesFull.get(response.article.id)
  };
});

const fetchArticleByGcmsId = ({ id }) => fetcher$2({
  query: `
      query Article($id: ID) {
          article(where: { id: $id}) {
            ${articleFields}
          }
      }`,
  variables: { id }
});

const fetchArticleByOldUrl = ({
  oldArticleUrl
}) => fetcher$2({
  query: `
      query Article($oldArticleUrl: String!) {
        articleUrls (where: { url: $oldArticleUrl }) {
          article {
            url
          }
        }
      }
    `,
  variables: { oldArticleUrl }
});

const fetchArticlePricings = ({
  productName
}) => fetcher$2({
  query: `
      query ArticlePrincings ($productName: String!) {
        articlePricings (where: { productName: $productName }, orderBy: wordCountMaximum_DESC) {
          price
          wordCountMaximum
        }
      }
    `,
  variables: { productName }
});

const fetchDistillery = ({
  id,
  after,
  pageSize,
  sortOrder = OrderOption.DESC
}) => {
  const orderBy = `updatedAt_${sortOrder}`;
  if (after) {
    return fetcher$2({
      query: `
      query ArticlesConnectionQuery( $after: String! $pageSize: Int $orderBy: ArticleOrderByInput) {
        articlesConnection(where: {primarySection : {name_contains: "Distillery"}} after: $after, first: $pageSize,  orderBy: $orderBy) {
          aggregate {
            count
          }
          pageInfo {
            pageSize
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
                ${articleFields}
            }
          }
          }
      }`,
      variables: {
        after,
        pageSize,
        orderBy,
        sortOrder
      }
    });
  }
  if (id) {
    return fetcher$2({
      query: `
        query ArticlesConnectionQuery( $id: ID) {
          articlesConnection(where: {primarySection : {name_contains: "Distillery"} id: $id}) {
            aggregate {
              count
            }
            pageInfo {
              pageSize
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                ${articleFields}
              }
            }
            }
        }`,
      variables: {
        id
      }
    });
  } else {
    return fetcher$2({
      query: `
        query ArticlesConnectionQuery( $pageSize: Int $orderBy: ArticleOrderByInput) {
          articlesConnection(where: {primarySection : {name_contains: "Distillery"}} first: $pageSize,  orderBy: $orderBy) {
            aggregate {
              count
            }
            pageInfo {
              pageSize
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                ${articleFields}
              }
            }
            }
        }`,
      variables: {
        pageSize,
        orderBy,
        sortOrder
      }
    });
  }
};

const editionFields = `
  type
  id
  editionDate
  startDate
  endDate
  editionPdf {
    url
  }
`;

var __defProp$5 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __async$b = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchEdition = (_0) => __async$b(void 0, [_0], function* ({ editionId }) {
  const edition = yield fetcher$2({
    query: `
      query Edition($editionId: ID!) {
          edition(where: { id: $editionId }) {
            ${editionFields}
            editionSections {
              id
              featuredSection
              bannerSection
              sortedArticleIds
              articles {
                __typename
                id
              }
            }
          }
      }`,
    variables: {
      editionId
    }
  });
  const articles = yield getEditionSectionArticles(edition);
  const components = yield getArticlesComponents([...articles.values()]);
  const articlesFull = mergeComponentsArticles(articles, components);
  edition.edition.editionSections = edition.edition.editionSections.map((edition2) => {
    return __spreadProps$2(__spreadValues$5({}, edition2), {
      articles: edition2.articles.map((article) => articlesFull.get(article.id) || article)
    });
  });
  return edition;
});
const getEditionSectionArticles = (edition) => __async$b(void 0, null, function* () {
  const articlesIds = /* @__PURE__ */ new Set();
  const articlesMap = /* @__PURE__ */ new Map();
  const editionSections = cloneDeep(edition.edition.editionSections);
  editionSections.forEach((edition2) => {
    edition2.articles.forEach((article) => articlesIds.add(article.id));
  });
  const articles = yield fetcher$2({
    query: `
      query Articles($ids: [ID!]) {
        articles(where: { id_in: $ids}) {
          ${articleFieldsSimplified}
        }
      }`,
    variables: {
      ids: [...articlesIds]
    }
  });
  articles.articles.forEach((article) => {
    articlesMap.set(article.id, article);
  });
  return articlesMap;
});

const fetchEditionPublicArticles = ({ editionId }) => fetcher$2({
  query: `
      query Edition($editionId: ID!) {
          edition (where: { id: $editionId }) {
            editionDate
            type
            editionSections {
              id
              section {
                name
              }
              featuredSection
              bannerSection
              sortedArticleIds
              articles {
                ${articlePublicFields}
              }
            }
          }
      }
    `,
  variables: {
    editionId
  }
});

const fetchEditionLatest = ({ type }) => fetcher$2({
  query: `
      query Editions {
          editions(where: { type: ${type} }, first: 12, orderBy: editionDate_DESC) {
            ${editionFields}
          }
      }`
});

const fetchEditionPDF = ({ editionId }) => fetcher$2({
  query: `
      query Edition($editionId: ID!) {
          edition(where: { id: $editionId }) {
            id
            __typename
            editionPdf {
              url
            }
            editionDate
            type
          }
      }`,
  variables: {
    editionId
  }
});

const fetchMarkdownComponent$1 = ({
  title
}) => {
  return fetcher$2({
    query: `
      query MarkdownQuery ($title: String!) {
        markdownComponents (where: { internalTitle: $title }) {
          id
          content
        }
      }
    `,
    variables: {
      title
    }
  });
};

var __async$a = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchDefaultPageDenied = (_0) => __async$a(void 0, [_0], function* ({
  preview,
  pageSize
}) {
  var _a;
  const enumDefaultDeniedPage = yield fetcher$2({
    query: `
      query EnumDefaultDeniedPage {
        __type(name: "DefaultPermissionDeniedPage") {
          enumValues {
            name
          }
        }
      }
    `,
    preview
  });
  const urlDeniedPage = (_a = enumDefaultDeniedPage.__type.enumValues[0]) == null ? void 0 : _a.name.replace(
    /[A-Z]/g,
    (word) => `-${word.toLowerCase()}`
  );
  const pageDenied = yield fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: { path: $path }) {
          id
        }
      }
    `,
    preview,
    variables: {
      path: urlDeniedPage,
      pageSize
    }
  });
  return pageDenied.page.id;
});

const fetchPageAlgoliaById = ({
  id,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($id: ID!) {
        page(where: { id: $id }) {
          stage
          ${pageAlgoliaFields}
        }

        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      id,
      pageSize
    }
  });
};

const fetchPageAlgoliaContent = ({
  path,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: { path: $path }) {
          stage
          ${pageAlgoliaFields}
        }

        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      path,
      pageSize
    }
  });
};

const fetchPageBasicContent = ({
  path,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: { path: $path }) {
          ${pageBasicFields}
        }
        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      path,
      pageSize
    }
  });
};

var __defProp$4 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __async$9 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const componentsMap = /* @__PURE__ */ new Map([
  ["ButtonComponent", ButtonComponent],
  ["CarouselComponent", CarouselComponent],
  ["CheckoutButtonComponent", CheckoutButtonComponent],
  ["CollapsibleComponent", CollapsibleComponent],
  ["CompaniesComponent", CompaniesComponent],
  ["ConferenceSection", ConferenceSection],
  ["ContentCardComponent", ContentCardComponent],
  ["InformativeCardComponent", InformativeCardComponent],
  ["GridComponent", GridComponent],
  ["LoginButtonComponent", LoginButtonComponent],
  ["MarkdownComponent", MarkdownComponent],
  ["MarketingCardComponent", MarketingCardComponent],
  ["MasoneryComponent", MasoneryFields],
  ["MyFeedComponent", MyFeedComponent],
  ["PeopleComponent", PeopleComponent],
  ["PodcastButtonComponent", PodcastButtonComponent],
  ["RegisterButtonComponent", RegisterButtonComponent],
  ["TabComponent", TabComponent],
  ["TabItemComponent", TabItemComponent],
  ["TitleComponent", TitleComponent]
]);
const fetchPageBlocks = (_0) => __async$9(void 0, [_0], function* ({ blocks, preview }) {
  try {
    const newBlocks = cloneDeep(blocks);
    const blocksMap = blocksToMap(newBlocks);
    const query = buildQuery(blocksMap);
    const response = yield fetcher$2({
      query,
      preview
    });
    let components = flatten$1(Object.values(response));
    const childrenBlocks = getChildrenBlocks(components);
    if (childrenBlocks.length > 0) {
      const fullChildrenBlocks = yield fetchPageBlocks({ blocks: childrenBlocks, preview });
      components = components.map((component) => {
        if (!component.blocks) {
          return component;
        }
        const newChildrenBlocks = mergeComponentsToBlocks(component.blocks, fullChildrenBlocks);
        return __spreadProps$1(__spreadValues$4({}, component), {
          blocks: newChildrenBlocks
        });
      });
    }
    const fullBlocks = mergeComponentsToBlocks(newBlocks, components);
    return Feed.parse(fullBlocks);
  } catch (err) {
    console.error(err);
    return blocks;
  }
});
function blocksToMap(blocks) {
  const blockMap = /* @__PURE__ */ new Map();
  blocks.forEach(({ __typename, id }) => {
    var _a;
    const ids = (_a = blockMap.get(__typename)) != null ? _a : [];
    blockMap.set(__typename, [...ids, `"${id}"`]);
  });
  return blockMap;
}
function buildQuery(blocks) {
  const queryArray = [];
  blocks.forEach((ids, typename) => {
    var _a;
    const pluralTypeName = BlockTypeNamePlural[camelCase(typename)];
    const query2 = `
      ${typename}: ${pluralTypeName} ( where: { id_in: [${ids}] }) {
        __typename
        ${(_a = componentsMap.get(typename)) != null ? _a : ""}
      }
    `;
    queryArray.push(query2);
  });
  const query = `
    query {
      ${queryArray.join("")}
    }
  `;
  return query;
}
function getChildrenBlocks(components) {
  const childrenBlocks = [];
  components.forEach((component) => {
    if (component.blocks && component.blocks.length > 0) {
      childrenBlocks.push(...component.blocks);
    }
  });
  return childrenBlocks;
}
function mergeComponentsToBlocks(blocks, components) {
  if (!blocks) {
    return [];
  }
  if (!components) {
    return blocks;
  }
  return blocks.map((block) => {
    const component = components.find((component2) => component2.id === block.id);
    return component != null ? component : block;
  });
}

const fetchPageContent = ({
  path,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: { path: $path }) {
          stage
          ${pageFields$1}
        }

        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      path,
      pageSize
    }
  });
};

const fetchPageFullContent = ({
  path,
  preview,
  pageSize
}) => {
  return fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: {path: $path}) {
          ${pageFullFields}
        }
        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      path,
      pageSize
    }
  });
};

const fetchPageMenu = ({ path, preview, pageSize }) => {
  return fetcher$2({
    query: `
      query PageQuery($path: String!) {
        page(where: { path: $path }) {
          __typename
          id
          title
          path
          product
          headline
          ${childrenPages}
          parentPage {
            path
            ${childrenPages}
            parentPage {
              path
              ${childrenPages}
            }
          }
        }
        urls {
          product
          url
        }
      }
    `,
    preview,
    variables: {
      path,
      pageSize
    }
  });
};

const fetchPagePath = ({ id }) => {
  return fetcher$2({
    query: `
      query PageQuery($id: ID!) {
        page(where: { id: $id }) {
          id
          path
        }
      }
    `,
    variables: { id }
  });
};
const fetchPageToPurge = () => {
  return fetcher$2({
    query: `
      query {
        pages(where: { purgeCache: true }) {
          id
          path
          purgeCache
        }
      }
    `
  });
};

const pageFields = `
  __typename
  id
  path
  redirectUrl
  redirectUrlMobile
`;
const fetchPageRedirects = (path) => {
  return fetcher$2({
    query: `
      query ($path: String!){
        page (where: { path: $path }) {
          ${pageFields}
          protected
          permission
          eventRequired {
            ... on Conference {
              __typename
              id
            }
          }

          loggedInPage {
            ${pageFields}
          }
          loggedOutPage {
            ${pageFields}
          }
          loggedInPageIP {
            ${pageFields}
          }
          permissionDeniedPage {
            ${pageFields}
          }
        }
      }
    `,
    variables: {
      path
    }
  });
};

const paywallFields = `
      __typename
      id
      paywallType
      blocks {
        __typename
        ... on ButtonComponent {
          ${ButtonComponent}
        }
        ... on LoginButtonComponent {
          ${LoginButtonComponent}
        }
        ... on CheckoutButtonComponent {
          ${CheckoutButtonComponent}
        }
        ... on RegisterButtonComponent {
          ${RegisterButtonComponent}
        }
        ... on TitleComponent {
          ${TitleComponent}
        }
        ... on MarkdownComponent {
          ${MarkdownComponent}
        }
        ... on ContentCardComponent {
          ${ContentCardComponent}
        }
        ... on MasoneryComponent {
          ${MasoneryFields}
        }
        ... on GridComponent {
          ${GridComponent}
        }
        ... on CollapsibleComponent {
          ${CollapsibleComponent}
        }
      }
  `;

const fetchPaywall = ({ paywallType }) => fetcher$2({
  query: `
      query paywall($paywallType: PaywallType!) {
          paywall(where: { paywallType: $paywallType}) {
            ${paywallFields}
          }
      }`,
  variables: { paywallType }
});

const fetchPublicationTemplates = ({
  name
}) => fetcher$2({
  query: `
      query PublicationTemplates ($name: String) {
        publicationTemplates (where: { name: $name }) {
          adContentUrl
          adContent {
            url
          }
          publicationTemplateRows (orderBy: sequenceIndex_ASC) {
            sequenceIndex
            section {
              id
              name
            }
          }
        }
      }
    `,
  variables: {
    name
  }
});

const fetchWhitepaper = ({ id }) => fetcher$2({
  query: `
      query Whitepaper($id: ID!) {
          whitepaper(where: { id: $id}) {
            ${whitepaper}
          }
      }`,
  variables: { id }
});

const fetchWhitepapers = ({
  after,
  pageSize,
  id,
  sortOrder = OrderOption.DESC
}) => {
  const orderBy = `updatedAt_${sortOrder}`;
  if (after) {
    return fetcher$2({
      query: `
        query WhitepapersConnectionQuery($after: String! $pageSize: Int $orderBy: WhiSpaperOrderByInput) {
          whitepapersConnection(after: $after, first: $pageSize,  orderBy: $orderBy) {
            aggregate {
              count
            }
            pageInfo {
              pageSize
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                ${whitepaper}
              }
            }
            }
        }`,
      variables: {
        after,
        pageSize,
        orderBy,
        sortOrder
      }
    });
  }
  if (id) {
    return fetcher$2({
      query: `
        query WhitepapersConnectionQuery($id: ID!) {
          whitepapersConnection(where: {id: $id } ) {
            aggregate {
              count
            }
            pageInfo {
              pageSize
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                ${whitepaper}
              }
            }
            }
        }`,
      variables: {
        after,
        pageSize,
        orderBy,
        id,
        sortOrder
      }
    });
  }
  return fetcher$2({
    query: `
      query whitepapersConnectionQuery( $pageSize: Int $orderBy: WhitepaperOrderByInput) {
        whitepapersConnection(first: $pageSize, orderBy: $orderBy) {
          aggregate {
            count
          }
          pageInfo {
            pageSize
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              ${whitepaper}
            }
          }
          }
      }
  `,
    variables: {
      pageSize,
      after,
      orderBy,
      sortOrder
    }
  });
};
const fetchWhitePaperByIds = (ids) => {
  return fetcher$2({
    query: `
    query WhitePaperQuery($ids: [ID!]) {
      whitepapers(where: { id_in: $ids }) {
        ${whitepaper}
      }
    }`,
    variables: {
      ids
    }
  });
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __async$8 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const graphCMSUrl = process.env.GRAPHCMS_PROJECT_ENDPOINT;
const graphCMSToken = process.env.GRAPHCMS_PUBLISHED_AUTH_TOKEN;
const uploadAsset = (file, filename) => __async$8(void 0, null, function* () {
  const form = new FormData();
  form.append("fileUpload", file, filename);
  const response = yield fetch(`${graphCMSUrl}/upload`, {
    method: "POST",
    headers: __spreadValues$3({
      Authorization: `Bearer ${graphCMSToken}`
    }, form.getHeaders()),
    body: form.getBuffer()
  });
  return response;
});
const publishAsset = (id) => {
  return fetcher$2({
    query: `
      mutation publishAsset ($id: ID!) {
        publishAsset(where: { id: $id }, to: PUBLISHED) {
          id
        }
      }
    `,
    variables: {
      id
    }
  });
};

const getCompanies = (page) => {
  var _a;
  const companies = (_a = page.blocks) == null ? void 0 : _a.map((block) => {
    if (block.__typename === "CompaniesComponent") {
      return block.companyGroups.map(
        ({ companies: companies2 }) => companies2.map((company) => company.name)
      );
    }
    if (block.__typename === "ConferenceSection") {
      return block.components.map((component) => {
        if (component.__typename === "CompaniesComponent") {
          return component.companyGroups.map(
            ({ companies: companies2 }) => companies2.map((company) => company.name)
          );
        }
      });
    }
  });
  return flow([flattenDeep, compact])(companies);
};
const getPeople = (page) => {
  var _a;
  const people = (_a = page.blocks) == null ? void 0 : _a.map((block) => {
    if (block.__typename === "PeopleComponent") {
      return block.people.map(({ name }) => name);
    }
    if (block.__typename === "ConferenceSection") {
      return block.components.map((component) => {
        if (component.__typename === "PeopleComponent") {
          return component.people.map(({ name }) => name);
        }
      });
    }
  });
  return flow([flattenDeep, compact])(people);
};
const getEvents = (page) => {
  var _a;
  const events = (_a = page.blocks) == null ? void 0 : _a.map((block) => {
    if (block.__typename === "ConferenceSection") {
      return block.components.map((component) => {
        if (component.__typename === "ScheduleComponent") {
          return component.events.map(({ title }) => title);
        }
      });
    }
  });
  return flow([flattenDeep, compact])(events);
};

const updateEdtionPDF = ({ id, editionPdf }) => {
  return fetcher$2({
    query: `
      mutation updateEditionPDF ($id: ID!, $editionPdf: AssetUpdateOneInlineInput!) {
        updateEdition(where: { id: $id }, data: { editionPdf: $editionPdf }) {
          id
        }
      }
    `,
    variables: {
      id,
      editionPdf: {
        connect: {
          id: editionPdf
        }
      }
    }
  });
};
const publishEdtion = (id) => {
  return fetcher$2({
    query: `
      mutation publishEdition ($id: ID!) {
        publishEdition(where: { id: $id }, to: PUBLISHED) {
          id
        }
      }
    `,
    variables: {
      id
    }
  });
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __async$7 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchAdControl = (_0) => __async$7(void 0, [_0], function* ({ page, article, types, categories }) {
  const response = yield fetcher$2({
    query: `
      query ($types: [ID!], $categories: [ID!], $article:ID, $page:ID) {
        adControls (
          orderBy: updatedAt_DESC,
          where: {OR: [
            {
              pages_some: {
                id: $page
              }
            },
            {
              article_some: {
                id: $article
              }
            }
            {
              articleTypes_some: {
                id_in: $types
              }
            }, 
            {
              articleCategories_some: {
                id_in: 
                $categories
              }
            }
          ]}
        ) {
          id
          controlName
          disableGoogleAdsOnComponent
          pages {
            id
          } 
          article {
            id
          }
          articleCategories {
            id
          }
          articleTypes {
            id
          }
          sponsorBanner {
            ${sponsorBannerFields}
          }
        }
      }
    `,
    variables: __spreadValues$2(__spreadValues$2(__spreadValues$2(__spreadValues$2({}, page && { page }), article && { article }), types && { types }), categories && { categories })
  });
  return response.adControls;
});

const fetchWarningMessage = () => fetcher$2({
  query: `
      query WarningMessages {
        warningMessage(where: {id: "cm9bcfr3306h807oe5lu5zhtc"}) {
          title
          shortenedBody
          body
          show
          showForEveryone
        }
      }
    `
});

const GraphCMS = {
  fetcher: fetcher$2,
  fetchAllPagePaths,
  fetchPageBasicContent,
  fetchPageFullContent,
  fetchPageBlocks,
  fetchPageAlgoliaContent,
  fetchPageContent,
  fetchDefaultPageDenied,
  fetchPageMenu,
  fetchPageAlgoliaById,
  fetchPageContentById,
  fetchPagePath,
  fetchPageToPurge,
  fetchPageRedirects,
  fetchPagePaths,
  fetchArticles,
  fetchArticle,
  fetchArticleByGcmsId,
  fetchArticleByOldUrl,
  fetchArticlesByIds,
  fetchArticlesCardByIds,
  fetchArticlePricings,
  fetchEdition,
  fetchEditionPDF,
  fetchEditionLatest,
  fetchEditionPublicArticles,
  fetchFeed,
  fetchPublicationTemplates,
  fetchPaywall,
  fetchAdControl,
  getCompanies,
  getPeople,
  getEvents,
  fetchDistillery,
  fetchWhitepaper,
  fetchWhitepapers,
  fetchWhitePaperByIds,
  fetchMarkdownComponent: fetchMarkdownComponent$1,
  fetchWarningMessage,
  uploadAsset,
  publishAsset,
  updateEdtionPDF,
  publishEdtion
};

const Monitoring = { Sentry };

var __async$6 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function withMethods(origHandler, methods) {
  return (req, res) => __async$6(this, null, function* () {
    if (!methods.includes(req.method)) {
      return res.status(405).json({ message: "Method not Allowed" });
    }
    return origHandler(req, res);
  });
}

var __async$5 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const WEBHOOK_SECRET = process.env.GRAPHCMS_WEBHOOK_SECRET;
function withWebSecret(origHandler) {
  return (req, res) => __async$5(this, null, function* () {
    const secret = req.headers["x-secret"];
    if (secret !== WEBHOOK_SECRET) {
      return res.status(401).json({ message: "Invalid token" });
    }
    return origHandler(req, res);
  });
}

const NextJS = {
  middleware: {
    withMethods,
    withWebSecret
  }
};

const navigationPages = (page) => {
  var _a, _b;
  const { parentPage, childrenPages } = page;
  const firstLayerPage = parentPage == null ? void 0 : parentPage.parentPage;
  const secondLayerPage = parentPage;
  return ((_a = firstLayerPage == null ? void 0 : firstLayerPage.childrenPages) == null ? void 0 : _a.length) && firstLayerPage.childrenPages || ((_b = secondLayerPage == null ? void 0 : secondLayerPage.childrenPages) == null ? void 0 : _b.length) && secondLayerPage.childrenPages || childrenPages;
};

const injectScript = (content, noParse = false) => {
  const window = Window.instance();
  if (noParse) {
    const scriptTag = window.document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.innerHTML = content;
    window.document.head.appendChild(scriptTag);
    return;
  }
  const placeholder = window.document.createElement("div");
  let replacedBody = content;
  replacedBody = replacedBody.replace(/&#x3C;/g, "<");
  replacedBody = replacedBody.replace(/&#x3E;/g, ">");
  placeholder.innerHTML = replacedBody;
  const scripts = placeholder.getElementsByTagName("script");
  Array.from(scripts).map((script) => {
    const scriptTag = window.document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.innerHTML = script.innerHTML;
    if (script.src) {
      scriptTag.src = script.src;
    }
    window.document.head.appendChild(scriptTag);
  });
};
const Scripts = { injectScript };

const Pages = { navigationPages, Scripts, Window };

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const apiURL = process.env.SEDJA_API;
const credentials = process.env.SEDJA_CREDENTIALS;
const fetcher$1 = (_0) => __async$4(void 0, [_0], function* ({
  html,
  url,
  isAzureFunction
}) {
  if (!apiURL) {
    throw new Error("No PDF API URL defined");
  }
  if (!credentials) {
    throw new Error("No PDF credentials defined");
  }
  const options = isAzureFunction ? {
    method: "POST",
    body: JSON.stringify(__spreadValues$1({}, url && { url })),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token: ${credentials}`
    }
  } : {
    method: "POST",
    body: JSON.stringify(__spreadProps(__spreadValues$1(__spreadValues$1({}, html && { htmlCode: html }), url && { url }), {
      pageSize: "letter",
      pageOrientation: "portrait",
      usePrintMedia: true,
      hideNotices: false,
      delay: 5
    })),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token: ${credentials}`
    }
  };
  return fetch(apiURL, options);
});

const domain = process.env.NEXT_PUBLIC_BIOCENTURY_URL;
const parseForPrint = (html) => {
  const document = parseDocument(html, {
    decodeEntities: true
  });
  removeTags(document);
  replaceRelativeURL(document);
  return render(document);
};
const removeTags = (document) => {
  const scripts = DomUtils.findAll((elem) => {
    if ("data-next-hide-fouc" in elem.attribs) {
      return true;
    }
    return false;
  }, document.children);
  scripts.map((elem) => {
    DomUtils.removeElement(elem);
  });
};
const replaceRelativeURL = (document) => {
  const elements = DomUtils.findAll((elem) => {
    var _a, _b, _c, _d;
    if ((_b = (_a = elem.attribs) == null ? void 0 : _a.href) == null ? void 0 : _b.startsWith("/")) {
      elem.attribs.href = `${domain}${elem.attribs.href}`;
      return true;
    }
    if ((_d = (_c = elem.attribs) == null ? void 0 : _c.src) == null ? void 0 : _d.startsWith("/")) {
      elem.attribs.src = `${domain}${elem.attribs.src}`;
      return true;
    }
    return false;
  }, document.children);
  return elements;
};

var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const htmlToPDF = (html) => __async$3(void 0, null, function* () {
  const htmlToPrint = parseForPrint(html);
  const response = yield fetcher$1({ html: htmlToPrint });
  if (response.status !== 200) {
    throw new Error(yield response.json());
  }
  if (response.headers.get("content-type") !== "application/pdf") {
    throw new Error("No PDF response");
  }
  const arrayBuffer = yield response.arrayBuffer();
  return Buffer.from(arrayBuffer);
});
const urlToPDF = (url, isAzureFunction) => __async$3(void 0, null, function* () {
  const response = yield fetcher$1({ url, isAzureFunction });
  if (response.status !== 200) {
    throw new Error(yield response.json());
  }
  if (response.headers.get("content-type") !== "application/pdf") {
    throw new Error("No PDF response");
  }
  const arrayBuffer = yield response.arrayBuffer();
  return Buffer.from(arrayBuffer);
});
const urlToPDFBlob = (url, isAzureFunction) => __async$3(void 0, null, function* () {
  const response = yield fetcher$1({ url, isAzureFunction });
  if (response.status !== 200) {
    throw new Error(yield response.json());
  }
  if (response.headers.get("content-type") !== "application/pdf") {
    throw new Error("No PDF response");
  }
  return response.blob();
});

const PrintPDF = {
  fetcher: fetcher$1,
  htmlToPDF,
  urlToPDF,
  urlToPDFBlob
};

const relatedPageFragment = `
  fragment relatedPage on Page {
    __typename
    id
    path
  }
`;
const titleComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    titleComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
      gridComponents {
        relatedPage {
          ... relatedPage
        }
      }
      tabItemComponents {
        tabComponents {
          relatedPage {
            ...relatedPage
          }
        }
      }
      carouselComponents {
        relatedPage {
          ...relatedPage
        }
      }
    }
  }
`;
const gridComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    gridComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
      tabItemComponents {
        tabComponents {
          relatedPage {
            ...relatedPage
          }
        }
      }
    }
  }
`;
const carouselComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    carouselComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
      tabItemComponents {
        tabComponents {
          relatedPage {
            ...relatedPage
          }
        }
      }
    }
  }
`;
const tabComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    tabComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
    }
  }
`;
const tabItemComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    tabItemComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      tabComponents {
        relatedPage {
          ... relatedPage
        }
      }
    }
  }
`;
const markdownComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    markdownComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
      gridComponents {
        relatedPage {
          ... relatedPage
        }
      }
      tabItemComponents {
        tabComponents {
          relatedPage {
            ...relatedPage
          }
        }
      }
    }
  }
`;
const peopleComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    peopleComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedPage {
        ... relatedPage
      }
      relatedConferenceSection {
        linkedPage { 
          ... relatedPage
        }
      }
    }
  }
`;
const ScheduleComponentQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    scheduleComponent (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedConferenceSection {
        linkedPage { 
          ... relatedPage
        }
      }
    }
  }
`;
const companyGroupQuery = `
  ${relatedPageFragment}

  query ($id:ID!, $stage: Stage!){
    companyGroup (where: {
      id: $id
    }, stage: $stage) {
      __typename
      id
      relatedCompaniesComponent {
        relatedPage { 
          ... relatedPage
        }
      }
    }
  }
`;
const relatedPagesQuery = `
  query ($ids:[ID!]!, $stage: Stage!){
    pages (where: {
      id_in: $ids
    }, stage: $stage) {
      __typename
      id
      path
    }
  }
`;

var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchTitleComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: titleComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.titleComponent;
});
const fetchGridComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: gridComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.gridComponent;
});
const fetchCarouselComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: carouselComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.carouselComponent;
});
const fetchTabComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: tabComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.tabComponent;
});
const fetchTabItemComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: tabItemComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.tabItemComponent;
});
const fetchMarkdownComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: markdownComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.markdownComponent;
});
const fetchPeopleComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: peopleComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.peopleComponent;
});
const fetchScheduleComponent = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: ScheduleComponentQuery,
    variables: {
      id,
      stage
    }
  });
  return response.scheduleComponent;
});
const fetchCompanyGroup = (_0) => __async$2(void 0, [_0], function* ({
  id,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: companyGroupQuery,
    variables: {
      id,
      stage
    }
  });
  return response.companyGroup;
});
const fetchRelatedPages = (_0) => __async$2(void 0, [_0], function* ({
  ids,
  stage = StageOption.PUBLISHED
}) {
  const response = yield fetcher$2({
    query: relatedPagesQuery,
    variables: {
      ids,
      stage
    }
  });
  return response;
});

const getRelatedPages = (data) => {
  var _a, _b, _c, _d, _e;
  let pages = [];
  if (data.relatedPage) {
    pages = [...pages, ...data.relatedPage];
  }
  if (data.pages) {
    pages = [...pages, ...data.pages];
  }
  (_a = data.gridComponents) == null ? void 0 : _a.forEach((grid) => {
    pages = [...pages, ...grid.relatedPage];
  });
  (_b = data.carouselComponents) == null ? void 0 : _b.forEach((carousel) => {
    pages = [...pages, ...carousel.relatedPage];
  });
  (_c = data.tabItemComponents) == null ? void 0 : _c.forEach((tabItems) => {
    tabItems.tabComponents.forEach((tab) => {
      pages = [...pages, ...tab.relatedPage];
    });
  });
  data.tabComponents.forEach((tab) => {
    pages = [...pages, ...tab.relatedPage];
  });
  (_d = data.relatedConferenceSection) == null ? void 0 : _d.forEach((section) => {
    pages = [...pages, ...[section.linkedPage]];
  });
  (_e = data.relatedCompaniesComponent) == null ? void 0 : _e.forEach((companies) => {
    pages = [...pages, ...companies.relatedPage];
  });
  return compact(uniq(pages.map((page) => page.path)));
};

const Purge = {
  fetch: {
    carouselComponent: fetchCarouselComponent,
    markdownComponent: fetchMarkdownComponent,
    gridComponent: fetchGridComponent,
    peopleComponent: fetchPeopleComponent,
    tabComponent: fetchTabComponent,
    tabItemComponent: fetchTabItemComponent,
    titleComponent: fetchTitleComponent,
    scheduleComponent: fetchScheduleComponent,
    companyGroup: fetchCompanyGroup,
    relatedPages: fetchRelatedPages
  },
  utils: {
    getRelatedPages
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetcherJSON = (_0) => __async$1(void 0, [_0], function* ({
  endpoint,
  method,
  body
}) {
  const supportingCastEndpoint = process.env.NEXT_PUBLIC_SUPPORTING_CAST_API_ENDPOINT;
  if (!supportingCastEndpoint) {
    throw new Error(
      "NEXT_PUBLIC_SUPPORTING_CAST_API_ENDPOINT not defined in env"
    );
  }
  const supportingCastClientToken = process.env.NEXT_PUBLIC_SUPPORTING_CAST_CLIENT_TOKEN;
  if (!supportingCastClientToken) {
    throw new Error(
      "NEXT_PUBLIC_SUPPORTING_CAST_CLIENT_TOKEN not defined in env"
    );
  }
  const url = `${supportingCastEndpoint}${endpoint}`;
  const response = yield fetch$2(url, __spreadValues({
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${supportingCastClientToken}`
    }
  }, body && {
    body
  }));
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    const responseBody = yield response.json();
    throw new Error(
      `Error, status: ${response.statusText}, error body: ${JSON.stringify(
        responseBody
      )}`
    );
  }
  const json = yield response.json();
  return json;
});
const fetcher = (_0) => __async$1(void 0, [_0], function* ({
  endpoint,
  method,
  body
}) {
  const supportingCastEndpoint = process.env.NEXT_PUBLIC_SUPPORTING_CAST_API_ENDPOINT;
  if (!supportingCastEndpoint) {
    throw new Error(
      "NEXT_PUBLIC_SUPPORTING_CAST_API_ENDPOINT not defined in env"
    );
  }
  const supportingCastClientToken = process.env.NEXT_PUBLIC_SUPPORTING_CAST_CLIENT_TOKEN;
  if (!supportingCastClientToken) {
    throw new Error(
      "NEXT_PUBLIC_SUPPORTING_CAST_CLIENT_TOKEN not defined in env"
    );
  }
  const url = `${supportingCastEndpoint}${endpoint}`;
  return fetch$2(url, __spreadValues({
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${supportingCastClientToken}`
    }
  }, body && {
    body
  }));
});

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const endpoints = {
  membership: (userEmail) => userEmail ? `/memberships/email=${userEmail}` : "/memberships"
};
const checkIfUserExists = (_0) => __async(void 0, [_0], function* ({
  email
}) {
  const result = yield fetcher({
    endpoint: endpoints.membership(email),
    method: RestMethods.GET
  });
  return result.ok;
});
const getUserInfo = (_0) => __async(void 0, [_0], function* ({
  email
}) {
  return yield fetcherJSON({
    endpoint: endpoints.membership(email),
    method: RestMethods.GET
  });
});
const addNewUser = (userInfo) => __async(void 0, null, function* () {
  return yield fetcherJSON({
    endpoint: endpoints.membership(),
    method: RestMethods.POST,
    body: JSON.stringify(userInfo)
  });
});
const updateUserPlan = (_0) => __async(void 0, [_0], function* ({
  email,
  plan_id
}) {
  return yield fetcherJSON({
    endpoint: endpoints.membership(email),
    method: RestMethods.PUT,
    body: JSON.stringify({ plan_id })
  });
});
const SupportingCastAPI = {
  checkIfUserExists,
  getUserInfo,
  addNewUser,
  updateUserPlan
};

const toLocalTime = (date) => {
  return DateTime.fromISO(date).toLocal();
};
const formatDateToApp = (date) => {
  return toLocalTime(date).toFormat("MMMM d, y");
};
const Time = { toLocalTime };

export { Algolia, Analytics, Article, ArticleAPI, Authentication, Authorization, BCIQ, Cache, CompanyAPI, DiseaseAPI, Domain, Feed, GraphCMS, Monitoring, MyWorkspaceAPI, NextJS, Pages, PowerBIAPI, PrintPDF, ProductAPI, Purge, SupportingCastAPI, TargetAPI, Time, formatDateToApp };
